import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { distinct } from '../utils/arrayUtilities';
import { readField } from '../utils/objectUtilities';
import { Col, Row } from './Grid';
import Label from './Label';
import Select from "./Select";
import TextInput from "./TextInput";
import TypeaheadInput from './TypeaheadInput';

export const toString = ({ value, defaultValue }) => {
    if (!value) {
        return defaultValue;
    }
    const fields = ['address1', 'address2', 'suburb', 'state', 'postcode']
    const values = fields.map(field => readField(value, field));
    return (values[0] ? values[0] + ', ' : '') + (values[1]? `${values[1]} ,` : '') + values.slice(2).join(' ');
}

// address1 - location
// address2 - village
// suburb - area council
// state - island
// postcode - province

const data = [
{village:'Abaone',province:'Sanma',island:'Malo'},
{village:'Abattoir',province:'Sanma',island:'Santo'},
{village:'Abuanga',province:'Penama',island:'Pentecost'},
{village:'Abulanga',province:'Penama',island:'Maewo'},
{village:'Abwalulua',province:'Penama',island:'Pentecost'},
{village:'Abwantuntora',province:'Penama',island:'Pentecost'},
{village:'Abwatariu',province:'Penama',island:'Pentecost'},
{village:'Abwatunbuliva',province:'Penama',island:'Pentecost'},
{village:'Abwatunmamalau',province:'Penama',island:'Pentecost'},
{village:'Abwatuntari',province:'Penama',island:'Pentecost'},
{village:'Abwatuntora',province:'Penama',island:'Pentecost'},
{village:'Abwatunvele',province:'Penama',island:'Maewo'},
{village:'Abwatunvutu',province:'Penama',island:'Pentecost'},
{village:'Abwatvenue',province:'Penama',island:'Pentecost'},
{village:'Adolala',province:'Sanma',island:'Malo'},
{village:'Adovonai',province:'Penama',island:'Pentecost'},
{village:'Aese',province:'Sanma',island:'Aese'},
{village:'Agatoa',province:'Penama',island:'Pentecost'},
{village:'Agriculture College',province:'Sanma',island:'Santo'},
{village:'Ahuku',province:'Penama',island:'Ambae'},
{village:'Alao',province:'Penama',island:'Maewo'},
{village:'Alememea',province:'Penama',island:'Pentecost'},
{village:'Alnunur',province:'Sanma',island:'Santo'},
{village:'Alologeha',province:'Penama',island:'Pentecost'},
{village:'Alowaru',province:'Sanma',island:'Malo'},
{village:'Amagalalau',province:'Penama',island:'Pentecost'},
{village:'Amagao',province:'Penama',island:'Pentecost'},
{village:'Amagilua',province:'Penama',island:'Pentecost'},
{village:'Amahirua',province:'Sanma',island:'Malo'},
{village:'Amalau',province:'Penama',island:'Pentecost'},
{village:'Amalo',province:'Sanma',island:'Malo'},
{village:'Amamwbea',province:'Sanma',island:'Malo'},
{village:'Amapelao',province:'Sanma',island:'Malo'},
{village:'Amata',province:'Penama',island:'Ambae'},
{village:'Amatbobo',province:'Penama',island:'Pentecost'},
{village:'Ambaebulu',province:'Penama',island:'Ambae'},
{village:'Ambaghura',province:'Sanma',island:'Malo'},
{village:'Ambanga',province:'Penama',island:'Ambae'},
{village:'Ambek',province:'Torba',island:'Vanua Lava'},
{village:'Ambilahe',province:'Sanma',island:'Malo'},
{village:'Ambore',province:'Penama',island:'Ambae'},
{village:'Amborosi',province:'Sanma',island:'Malo'},
{village:'Amelhubwe',province:'Penama',island:'Pentecost'},
{village:'Ampatuwotu',province:'Sanma',island:'Malo'},
{village:'Amseran',province:'Sanma',island:'Mavea'},
{village:'Angerena',province:'Penama',island:'Pentecost'},
{village:'Angoro',province:'Penama',island:'Pentecost'},
{village:'Angwet',province:'Torba',island:'Gaua'},
{village:'Ankuru',province:'Sanma',island:'Santo'},
{village:'Anmalabua',province:'Penama',island:'Pentecost'},
{village:'Anusa',province:'Sanma',island:'Tutuba'},
{village:'Aota',province:'Torba',island:'Mere Lava'},
{village:'Apersula',province:'Sanma',island:'Malo'},
{village:'Apopo',province:'Penama',island:'Ambae'},
{village:'Araki',province:'Sanma',island:'Araki'},
{village:'Arantoa',province:'Sanma',island:'Santo'},
{village:'Arasa',province:'Penama',island:'Pentecost'},
{village:'Aravita',province:'Sanma',island:'Malo'},
{village:'Arep',province:'Torba',island:'Vanua Lava'},
{village:'Arevo',province:'Penama',island:'Pentecost'},
{village:'Arivrivbarai',province:'Penama',island:'Pentecost'},
{village:'Aroa',province:'Penama',island:'Pentecost'},
{village:'Arohan',province:'Sanma',island:'Malo'},
{village:'Arongbwaratu',province:'Penama',island:'Pentecost'},
{village:'Arongbwratu',province:'Penama',island:'Pentecost'},
{village:'Arorono',province:'Penama',island:'Ambae'},
{village:'Asalmangaru',province:'Penama',island:'Pentecost'},
{village:'Asamaranda',province:'Sanma',island:'Malo'},
{village:'Asanasa',province:'Sanma',island:'Malo'},
{village:'Asanawari',province:'Sanma',island:'Malo'},
{village:'Asanvari',province:'Penama',island:'Maewo'},
{village:'Asaola',province:'Penama',island:'Pentecost'},
{village:'Asaratamata',province:'Penama',island:'Pentecost'},
{village:'Asataleva',province:'Penama',island:'Maewo'},
{village:'Asatapu',province:'Sanma',island:'Malo'},
{village:'Atabualasi',province:'Penama',island:'Pentecost'},
{village:'Atabuau',province:'Penama',island:'Pentecost'},
{village:'Atabulu',province:'Penama',island:'Pentecost'},
{village:'Atalisa',province:'Sanma',island:'Malo'},
{village:'Atangurua',province:'Penama',island:'Pentecost'},
{village:'Ataripoi',province:'Sanma',island:'Malo'},
{village:'Atavoa',province:'Penama',island:'Ambae'},
{village:'Atavtabanga',province:'Penama',island:'Pentecost'},
{village:'Ativusa',province:'Sanma',island:'Malo'},
{village:'Atkor',province:'Torba',island:'Gaua'},
{village:'Avanbatai',province:'Penama',island:'Maewo'},
{village:'Avanguresi',province:'Penama',island:'Pentecost'},
{village:'Avantavoa',province:'Penama',island:'Pentecost'},
{village:'Avar',province:'Torba',island:'Mota Lava'},
{village:'Avatuna',province:'Penama',island:'Pentecost'},
{village:'Avatvotu',province:'Penama',island:'Pentecost'},
{village:'Avavanvae',province:'Penama',island:'Maewo'},
{village:'Aver',province:'Torba',island:'Gaua'},
{village:'Aviriana',province:'Penama',island:'Pentecost'},
{village:'Avorani',province:'Sanma',island:'Malo'},
{village:'Avulavotu',province:'Penama',island:'Pentecost'},
{village:'Avunabahura',province:'Sanma',island:'Malo'},
{village:'Avunabuho',province:'Sanma',island:'Malo'},
{village:'Avunabulu',province:'Sanma',island:'Malo'},
{village:'Avunaleleo',province:'Sanma',island:'Malo'},
{village:'Avunambaka',province:'Sanma',island:'Malo'},
{village:'Avunambakaliko',province:'Sanma',island:'Malo'},
{village:'Avunambue',province:'Sanma',island:'Malo'},
{village:'Avunarani',province:'Sanma',island:'Malo'},
{village:'Avunarara',province:'Sanma',island:'Malo'},
{village:'Avunaresi',province:'Sanma',island:'Malo'},
{village:'Avunareworewo',province:'Sanma',island:'Malo'},
{village:'Avunatangi',province:'Sanma',island:'Malo'},
{village:'Avunatari',province:'Sanma',island:'Malo'},
{village:'Avunatavoa',province:'Sanma',island:'Malo'},
{village:'Avunavae',province:'Sanma',island:'Malo'},
{village:'Aworor',province:'Torba',island:'Gaua'},
{village:'Baie Barrier',province:'Penama',island:'Pentecost'},
{village:'Baitora',province:'Penama',island:'Maewo'},
{village:'Bakataura',province:'Sanma',island:'Santo'},
{village:'Bakra',province:'Penama',island:'Maewo'},
{village:'Bamboo',province:'Sanma',island:'Santo'},
{village:'Banban',province:'Sanma',island:'Santo'},
{village:'Banban Bush',province:'Sanma',island:'Santo'},
{village:'Banmit',province:'Penama',island:'Pentecost'},
{village:'Baol',province:'Torba',island:'Gaua'},
{village:'Barakel',province:'Sanma',island:'Malo'},
{village:'Baravet (Gaua)',province:'Torba',island:'Gaua'},
{village:'Baravet (Pentecost)',province:'Penama',island:'Pentecost'},
{village:'Barick',province:'Sanma',island:'Santo'},
{village:'Barrick',province:'Sanma',island:'Santo'},
{village:'Bavulava',province:'Penama',island:'Ambae'},
{village:'Belbarav',province:'Sanma',island:'Santo'},
{village:'Beleru',province:'Sanma',island:'Santo'},
{village:'Bellemolle',province:'Sanma',island:'Santo'},
{village:'Belnatsa',province:'Sanma',island:'Santo'},
{village:'Belotu',province:'Sanma',island:'Santo'},
{village:'Bene',province:'Sanma',island:'Santo'},
{village:'Benmoli',province:'Sanma',island:'Santo'},
{village:'Beterara',province:'Penama',island:'Maewo'},
{village:'Bethel(Santo)',province:'Sanma',island:'Santo'},
{village:'Bethlehem (Malo)',province:'Sanma',island:'Malo'},
{village:'Betrihi',province:'Sanma',island:'Malo'},
{village:'Bia',province:'Sanma',island:'Santo'},
{village:'Biam',province:'Torba',island:'Gaua'},
{village:'Bines',province:'Penama',island:'Pentecost'},
{village:'Biribiri',province:'Penama',island:'Ambae'},
{village:'Bobby Plantation',province:'Sanma',island:'Santo'},
{village:'Bohoro',province:'Penama',island:'Maewo'},
{village:'Boiboi',province:'Penama',island:'Ambae'},
{village:'Bokissa',province:'Sanma',island:'Bokissa'},
{village:'Bokrat',province:'Torba',island:'Vanua Lava'},
{village:'Bompua',province:'Sanma',island:'Santo'},
{village:'Bondum',province:'Sanma',island:'Santo'},
{village:'Bosgole',province:'Penama',island:'Maewo'},
{village:'Bowul',province:'Penama',island:'Pentecost'},
{village:'Bp Bon',province:'Sanma',island:'Santo'},
{village:'Buabua',province:'Penama',island:'Maewo'},
{village:'Bulhak',province:'Penama',island:'Pentecost'},
{village:'Bune',province:'Sanma',island:'Santo'},
{village:'Bunlap',province:'Penama',island:'Pentecost'},
{village:'Burie',province:'Sanma',island:'Santo'},
{village:'Busman Bay',province:'Torba',island:'Gaua'},
{village:'Butmas',province:'Sanma',island:'Santo'},
{village:'Bwaga',province:'Penama',island:'Pentecost'},
{village:'Bwatnapni',province:'Penama',island:'Pentecost'},
{village:'Bwilaut',province:'Penama',island:'Pentecost'},
{village:'Bye',province:'Sanma',island:'Santo'},
{village:'Canal',province:'Sanma',island:'Santo'},
{village:'Carvel',province:'Sanma',island:'Santo'},
{village:'Chapuis 1',province:'Sanma',island:'Santo'},
{village:'Chapuis 2',province:'Sanma',island:'Santo'},
{village:'Demsas 1',province:'Torba',island:'Mota Lava'},
{village:'Demsas 2',province:'Torba',island:'Mota Lava'},
{village:'Deproma',province:'Sanma',island:'Santo'},
{village:'Din Shipping Bush',province:'Sanma',island:'Santo'},
{village:'Dineumevuneu',province:'Torba',island:'Hiu'},
{village:'Dinh Shipping',province:'Sanma',island:'Santo'},
{village:'Dirihi',province:'Penama',island:'Pentecost'},
{village:'Dolav',province:'Torba',island:'Gaua'},
{village:'Dorig',province:'Torba',island:'Gaua'},
{village:'Dun-Hill',province:'Sanma',island:'Santo'},
{village:'Ebenezer',province:'Sanma',island:'Santo'},
{village:'Ebwelip',province:'Penama',island:'Pentecost'},
{village:'Eken',province:'Sanma',island:'Santo'},
{village:'Elia',province:'Sanma',island:'Santo'},
{village:'Elislis',province:'Penama',island:'Pentecost'},
{village:'Ena',province:'Penama',island:'Pentecost'},
{village:'Enbanga Matmat',province:'Penama',island:'Pentecost'},
{village:'Enbangoa',province:'Penama',island:'Pentecost'},
{village:'Enkem',province:'Penama',island:'Pentecost'},
{village:'Enkok',province:'Penama',island:'Pentecost'},
{village:'Envelbwavi',province:'Penama',island:'Pentecost'},
{village:'Faboun',province:'Sanma',island:'Santo'},
{village:'Fanafo',province:'Sanma',island:'Santo'},
{village:'Fimele',province:'Sanma',island:'Santo'},
{village:'Firestation',province:'Sanma',island:'Santo'},
{village:'Forjenale',province:'Sanma',island:'Santo'},
{village:'Frank Joe',province:'Sanma',island:'Aore'},
{village:'Freshwind',province:'Sanma',island:'Santo'},
{village:'Fulamkara',province:'Sanma',island:'Santo'},
{village:'Funafosi',province:'Sanma',island:'Santo'},
{village:'Funaspef',province:'Sanma',island:'Santo'},
{village:'Gamalna',province:'Torba',island:'Mota'},
{village:'Garamal',province:'Torba',island:'Mota'},
{village:'Gatteville',province:'Sanma',island:'Aore'},
{village:'Genesis',province:'Sanma',island:'Malo'},
{village:'George Lini',province:'Sanma',island:'Aore'},
{village:'Gerr',province:'Sanma',island:'Santo'},
{village:'Ghantaroa',province:'Penama',island:'Maewo'},
{village:'Gingonikoru',province:'Sanma',island:'Malo'},
{village:'Giraud',province:'Sanma',island:'Aore'},
{village:'Gun',province:'Penama',island:'Pentecost'},
{village:'Hala',province:'Sanma',island:'Santo'},
{village:'Halalulu',province:'Penama',island:'Ambae'},
{village:'Halatamarino',province:'Penama',island:'Ambae'},
{village:'Halovu',province:'Penama',island:'Ambae'},
{village:'Harop',province:'Penama',island:'Pentecost'},
{village:'Hasevaia',province:'Sanma',island:'Santo'},
{village:'Hog Harbour',province:'Sanma',island:'Santo'},
{village:'Hokua',province:'Sanma',island:'Santo'},
{village:'Homo Bay',province:'Penama',island:'Pentecost'},
{village:'Hospital',province:'Sanma',island:'Santo'},
{village:'Hot Wota',province:'Penama',island:'Pentecost'},
{village:'Hubiku',province:'Penama',island:'Pentecost'},
{village:'Hukoro',province:'Sanma',island:'Santo'},
{village:'Ilamre',province:'Penama',island:'Pentecost'},
{village:'Ipayato',province:'Sanma',island:'Santo'},
{village:'Ircc',province:'Sanma',island:'Santo'},
{village:'Irho',province:'Sanma',island:'Santo'},
{village:'Jarailan',province:'Sanma',island:'Santo'},
{village:'Jarakoru',province:'Sanma',island:'Santo'},
{village:'Jaranavusvus',province:'Sanma',island:'Santo'},
{village:'Jaranikey',province:'Sanma',island:'Santo'},
{village:'Jaraty',province:'Sanma',island:'Santo'},
{village:'Jaravalivu',province:'Sanma',island:'Santo'},
{village:'Jereviu',province:'Sanma',island:'Santo'},
{village:'Jingontana',province:'Sanma',island:'Malo'},
{village:'Jinoitavara',province:'Sanma',island:'Santo'},
{village:'Jinopoe',province:'Sanma',island:'Santo'},
{village:'Jinotavara',province:'Sanma',island:'Santo'},
{village:'Jubilee Farm',province:'Sanma',island:'Santo'},
{village:'Kamalbakeo',province:'Penama',island:'Ambae'},
{village:'Kamalia Lao',province:'Penama',island:'Maewo'},
{village:'Kandilivu',province:'Penama',island:'Ambae'},
{village:'Kerei',province:'Sanma',island:'Santo'},
{village:'Kereiparana',province:'Sanma',island:'Santo'},
{village:'Kereliu',province:'Torba',island:'Gaua'},
{village:'Kerembei',province:'Penama',island:'Maewo'},
{village:'Kerembita',province:'Torba',island:'Vanua Lava'},
{village:'Keren Tavui',province:'Sanma',island:'Santo'},
{village:'Kerepua',province:'Sanma',island:'Santo'},
{village:'Kerevinompu',province:'Sanma',island:'Santo'},
{village:'Kervalise',province:'Sanma',island:'Santo'},
{village:'Keyembak',province:'Torba',island:'Vanua Lava'},
{village:'Kisule',province:'Sanma',island:'Santo'},
{village:'Kole 1',province:'Sanma',island:'Santo'},
{village:'Kole 2',province:'Sanma',island:'Santo'},
{village:'Kona',province:'Sanma',island:'Santo'},
{village:'Koro',province:'Torba',island:'Gaua'},
{village:'Kororo',province:'Sanma',island:'Santo'},
{village:'Kowi',province:'Penama',island:'Pentecost'},
{village:'Kraiowo',province:'Penama',island:'Maewo'},
{village:'Kulbaga',province:'Penama',island:'Pentecost'},
{village:'Kumreut',province:'Penama',island:'Pentecost'},
{village:'Kutan',province:'Penama',island:'Pentecost'},
{village:'Kuvulo',province:'Sanma',island:'Santo'},
{village:'Kwainavoha',province:'Penama',island:'Ambae'},
{village:'Kwakea',province:'Torba',island:'Kwakea'},
{village:'Kweteon',province:'Torba',island:'Gaua'},
{village:'Kwururetokwa',province:'Torba',island:'Toga'},
{village:'Labaru',province:'Penama',island:'Pentecost'},
{village:'Labultamata',province:'Penama',island:'Pentecost'},
{village:'Labwaen',province:'Penama',island:'Pentecost'},
{village:'Labwaru',province:'Penama',island:'Pentecost'},
{village:'Labwarunsivi',province:'Penama',island:'Pentecost'},
{village:'Labwatgarabihu',province:'Penama',island:'Pentecost'},
{village:'Labwatgongoro',province:'Penama',island:'Pentecost'},
{village:'Labwatgugu',province:'Penama',island:'Pentecost'},
{village:'Labwatmalihlihi',province:'Penama',island:'Pentecost'},
{village:'Lagaronboga',province:'Penama',island:'Pentecost'},
{village:'Lagatava',province:'Penama',island:'Pentecost'},
{village:'Lagaviga',province:'Penama',island:'Pentecost'},
{village:'Lahalbulbulu',province:'Penama',island:'Pentecost'},
{village:'Lajmoli',province:'Sanma',island:'Santo'},
{village:'Lakinaekinae',province:'Sanma',island:'Santo'},
{village:'Lalangnam',province:'Penama',island:'Maewo'},
{village:'Lalaundie',province:'Penama',island:'Maewo'},
{village:'Lalavara',province:'Penama',island:'Maewo'},
{village:'Lalavaru',province:'Penama',island:'Maewo'},
{village:'Lalmamring',province:'Penama',island:'Pentecost'},
{village:'Lalnete',province:'Torba',island:'Vanua Lava'},
{village:'Lalvetaes',province:'Penama',island:'Pentecost'},
{village:'Lalwok',province:'Penama',island:'Pentecost'},
{village:'Lalwori',province:'Penama',island:'Pentecost'},
{village:'Lalwuk',province:'Penama',island:'Pentecost'},
{village:'Lambetra',province:'Sanma',island:'Malo'},
{village:'Lambue',province:'Sanma',island:'Santo'},
{village:'Lamelis',province:'Sanma',island:'Santo'},
{village:'Lamoru',province:'Penama',island:'Pentecost'},
{village:'Lamuruntoa',province:'Penama',island:'Pentecost'},
{village:'Langetak',province:'Torba',island:'Vanua Lava'},
{village:'Lanop',province:'Sanma',island:'Santo'},
{village:'Laone',province:'Penama',island:'Pentecost'},
{village:'Lape',province:'Sanma',island:'Santo'},
{village:'Lapita Plantation',province:'Sanma',island:'Aore'},
{village:'Lare',province:'Penama',island:'Pentecost'},
{village:'Larouk',province:'Penama',island:'Pentecost'},
{village:'Lasive',province:'Penama',island:'Pentecost'},
{village:'Latan Dumdumi',province:'Penama',island:'Maewo'},
{village:'Latano',province:'Penama',island:'Pentecost'},
{village:'Lateu',province:'Torba',island:'Tegua'},
{village:'Lathi',province:'Sanma',island:'Santo'},
{village:'Laum',province:'Sanma',island:'Santo'},
{village:'Laumu',province:'Penama',island:'Pentecost'},
{village:'Lavanutagaro',province:'Penama',island:'Pentecost'},
{village:'Lavatgaivelu',province:'Penama',island:'Pentecost'},
{village:'Lavatnalau',province:'Sanma',island:'Santo'},
{village:'Lavatu',province:'Penama',island:'Maewo'},
{village:'Lavora',province:'Penama',island:'Maewo'},
{village:'Lavusi',province:'Penama',island:'Pentecost'},
{village:'Lavusvatu',province:'Sanma',island:'Santo'},
{village:'Lawai',province:'Penama',island:'Pentecost'},
{village:'Lawelena',province:'Penama',island:'Pentecost'},
{village:'Lebaen',province:'Torba',island:'Gaua'},
{village:'Lebal',province:'Torba',island:'Gaua'},
{village:'Lebathi',province:'Penama',island:'Pentecost'},
{village:'Lebetabok',province:'Penama',island:'Pentecost'},
{village:'Lebetamit',province:'Penama',island:'Pentecost'},
{village:'Lebor',province:'Penama',island:'Pentecost'},
{village:'Lebujubujuvet',province:'Penama',island:'Pentecost'},
{village:'Lebundog',province:'Penama',island:'Pentecost'},
{village:'Lebus',province:'Penama',island:'Pentecost'},
{village:'Lebwa',province:'Penama',island:'Pentecost'},
{village:'Lebwibwi',province:'Penama',island:'Pentecost'},
{village:'Ledowar',province:'Torba',island:'Gaua'},
{village:'Ledunsivi',province:'Penama',island:'Pentecost'},
{village:'Le\'Ev',province:'Torba',island:'Vanua Lava'},
{village:'Legawenda',province:'Torba',island:'Gaua'},
{village:'Leguru',province:'Penama',island:'Pentecost'},
{village:'Lehali',province:'Torba',island:'Ureparapara'},
{village:'Leithesi',province:'Sanma',island:'Santo'},
{village:'Lekal',province:'Penama',island:'Pentecost'},
{village:'Lekaro',province:'Penama',island:'Pentecost'},
{village:'Lekatraba',province:'Penama',island:'Pentecost'},
{village:'Lekul',province:'Penama',island:'Pentecost'},
{village:'Lekwel',province:'Torba',island:'Mere Lava'},
{village:'Lekwiyangle',province:'Torba',island:'Ureparapara'},
{village:'Lelek',province:'Sanma',island:'Santo'},
{village:'Lelislis',province:'Penama',island:'Pentecost'},
{village:'Lemaba',province:'Penama',island:'Pentecost'},
{village:'Lemalda',province:'Penama',island:'Pentecost'},
{village:'Lemamleke',province:'Penama',island:'Pentecost'},
{village:'Lemanman',province:'Torba',island:'Gaua'},
{village:'Lematete',province:'Penama',island:'Pentecost'},
{village:'Lemaviko',province:'Penama',island:'Pentecost'},
{village:'Lembot 1',province:'Torba',island:'Gaua'},
{village:'Lembot 2',province:'Torba',island:'Gaua'},
{village:'Lemoga',province:'Torba',island:'Gaua'},
{village:'Lenbok',province:'Penama',island:'Pentecost'},
{village:'Lenga',province:'Penama',island:'Pentecost'},
{village:'Lengali',province:'Penama',island:'Pentecost'},
{village:'Lense',province:'Penama',island:'Pentecost'},
{village:'Lenwaki',province:'Penama',island:'Pentecost'},
{village:'Leodova',province:'Penama',island:'Pentecost'},
{village:'Leon',province:'Torba',island:'Vanua Lava'},
{village:'Lerankaro',province:'Penama',island:'Pentecost'},
{village:'Lerasangul',province:'Penama',island:'Pentecost'},
{village:'Lerat',province:'Torba',island:'Mere Lava'},
{village:'Leravinanposvi',province:'Penama',island:'Pentecost'},
{village:'Lerukruk',province:'Penama',island:'Pentecost'},
{village:'Lesa',province:'Torba',island:'Vanua Lava'},
{village:'Lesarintemwat',province:'Penama',island:'Pentecost'},
{village:'Lesasa',province:'Penama',island:'Pentecost'},
{village:'Lesasa Namal',province:'Penama',island:'Pentecost'},
{village:'Lesasanadam',province:'Penama',island:'Pentecost'},
{village:'Lesereplag',province:'Torba',island:'Ureparapara'},
{village:'Lesubelakan',province:'Penama',island:'Pentecost'},
{village:'Lesus',province:'Torba',island:'Gaua'},
{village:'Lethesi',province:'Sanma',island:'Santo'},
{village:'Letoror',province:'Sanma',island:'Santo'},
{village:'Levatkainmel',province:'Penama',island:'Pentecost'},
{village:'Levelkaak',province:'Penama',island:'Pentecost'},
{village:'Levetlis',province:'Penama',island:'Pentecost'},
{village:'Levetmisse',province:'Torba',island:'Mere Lava'},
{village:'Levilhi',province:'Penama',island:'Pentecost'},
{village:'Levini',province:'Penama',island:'Pentecost'},
{village:'Levisendam',province:'Penama',island:'Pentecost'},
{village:'Levog',province:'Torba',island:'Gaua'},
{village:'Levolvol',province:'Torba',island:'Merig'},
{village:'Levow',province:'Torba',island:'Gaua'},
{village:'Levuk',province:'Penama',island:'Pentecost'},
{village:'Levundo',province:'Penama',island:'Pentecost'},
{village:'Lewabwarangmet',province:'Penama',island:'Pentecost'},
{village:'Lewakabet',province:'Penama',island:'Pentecost'},
{village:'Lewawa',province:'Penama',island:'Pentecost'},
{village:'Lewotniok',province:'Torba',island:'Mere Lava'},
{village:'Libetalalak',province:'Penama',island:'Pentecost'},
{village:'Libukuvini',province:'Penama',island:'Pentecost'},
{village:'Libwipeta',province:'Penama',island:'Pentecost'},
{village:'Lihiwuk',province:'Penama',island:'Pentecost'},
{village:'Lijukunkasi',province:'Penama',island:'Pentecost'},
{village:'Likasak',province:'Penama',island:'Pentecost'},
{village:'Likwal',province:'Torba',island:'Toga'},
{village:'Linduri',province:'Sanma',island:'Santo'},
{village:'Linua',province:'Torba',island:'Loh'},
{village:'Litow',province:'Torba',island:'Vanua Lava'},
{village:'Liwotkei',province:'Torba',island:'Mota'},
{village:'Lobasa',province:'Penama',island:'Ambae'},
{village:'Logaitureitovu',province:'Penama',island:'Ambae'},
{village:'Loguigui',province:'Penama',island:'Ambae'},
{village:'Logwaruibui',province:'Penama',island:'Ambae'},
{village:'Loheut',province:'Sanma',island:'Santo'},
{village:'Lohueri',province:'Penama',island:'Ambae'},
{village:'Loigememea',province:'Penama',island:'Ambae'},
{village:'Lokalee',province:'Sanma',island:'Santo'},
{village:'Lolbiribirishul',province:'Penama',island:'Pentecost'},
{village:'Lolbuavatu',province:'Penama',island:'Pentecost'},
{village:'Lolbwahu',province:'Penama',island:'Pentecost'},
{village:'Loloara',province:'Penama',island:'Ambae'},
{village:'Loloaru',province:'Penama',island:'Ambae'},
{village:'Lolobaego',province:'Penama',island:'Ambae'},
{village:'Lolobaka',province:'Penama',island:'Ambae'},
{village:'Lolobinanungwa',province:'Penama',island:'Ambae'},
{village:'Lolobivune',province:'Penama',island:'Ambae'},
{village:'Lolobue',province:'Penama',island:'Ambae'},
{village:'Lolobulusi',province:'Penama',island:'Ambae'},
{village:'Lolokesa',province:'Penama',island:'Ambae'},
{village:'Lololase',province:'Penama',island:'Ambae'},
{village:'Lolomanganda',province:'Penama',island:'Ambae'},
{village:'Lolomatui',province:'Penama',island:'Ambae'},
{village:'Lolomavuro',province:'Penama',island:'Ambae'},
{village:'Lolombanga',province:'Penama',island:'Ambae'},
{village:'Lolonduvu',province:'Penama',island:'Ambae'},
{village:'Lolongo Baeko',province:'Penama',island:'Ambae'},
{village:'Lolongwalakesa',province:'Penama',island:'Ambae'},
{village:'Lolongwele',province:'Penama',island:'Ambae'},
{village:'Lolonkarbush',province:'Sanma',island:'Santo'},
{village:'Lolopepa',province:'Penama',island:'Ambae'},
{village:'Lolopuepue',province:'Penama',island:'Ambae'},
{village:'Lolosara',province:'Penama',island:'Ambae'},
{village:'Lolosigei',province:'Penama',island:'Ambae'},
{village:'Lolosiwoi',province:'Penama',island:'Ambae'},
{village:'Lolosori',province:'Penama',island:'Ambae'},
{village:'Lolotari',province:'Penama',island:'Ambae'},
{village:'Lolotawaewae',province:'Penama',island:'Ambae'},
{village:'Lolovange',province:'Penama',island:'Ambae'},
{village:'Lolovatali',province:'Penama',island:'Ambae'},
{village:'Loltayap',province:'Penama',island:'Ambae'},
{village:'Lolovele',province:'Penama',island:'Ambae'},
{village:'Lolovelevusi',province:'Penama',island:'Ambae'},
{village:'Lolovenue',province:'Penama',island:'Ambae'},
{village:'Loloveveo',province:'Penama',island:'Ambae'},
{village:'Lolovoli',province:'Penama',island:'Ambae'},
{village:'Lolowai',province:'Penama',island:'Ambae'},
{village:'Lolowalu',province:'Penama',island:'Ambae'},
{village:'Loltoi',province:'Penama',island:'Pentecost'},
{village:'Loltong',province:'Penama',island:'Pentecost'},
{village:'Lomaeto',province:'Penama',island:'Ambae'},
{village:'Lomaki',province:'Penama',island:'Ambae'},
{village:'Lomalanga',province:'Penama',island:'Ambae'},
{village:'Lomalangai Tambe',province:'Penama',island:'Ambae'},
{village:'Lomanioc',province:'Sanma',island:'Santo'},
{village:'Lombanga',province:'Penama',island:'Ambae'},
{village:'Lombonoi',province:'Penama',island:'Ambae'},
{village:'Lonapin',province:'Penama',island:'Pentecost'},
{village:'Lonbwe (Pentecost)',province:'Penama',island:'Pentecost'},
{village:'Londar',province:'Penama',island:'Pentecost'},
{village:'Londua',province:'Penama',island:'Ambae'},
{village:'Longbwe',province:'Penama',island:'Pentecost'},
{village:'Longwaru (West Ambae)',province:'Penama',island:'Ambae'},
{village:'Longwaruhivirengwele',province:'Penama',island:'Ambae'},
{village:'Longwaruibui',province:'Penama',island:'Ambae'},
{village:'Longwaruisiwo',province:'Penama',island:'Ambae'},
{village:'Longwirutaro',province:'Penama',island:'Ambae'},
{village:'Lonisis',province:'Penama',island:'Pentecost'},
{village:'Lonlia',province:'Penama',island:'Pentecost'},
{village:'Lonlibwe',province:'Penama',island:'Pentecost'},
{village:'Lonoc',province:'Sanma',island:'Santo'},
{village:'Lonorore',province:'Penama',island:'Pentecost'},
{village:'Lonunu',province:'Penama',island:'Ambae'},
{village:'Loone',province:'Penama',island:'Ambae'},
{village:'Loone Kukwehu',province:'Penama',island:'Ambae'},
{village:'Loone Lakua',province:'Penama',island:'Ambae'},
{village:'Lo-Onekwekwehu',province:'Penama',island:'Ambae'},
{village:'Lopelope',province:'Sanma',island:'Santo'},
{village:'Loran',province:'Sanma',island:'Santo'},
{village:'Lorethikarkar',province:'Sanma',island:'Santo'},
{village:'Lorevulko',province:'Sanma',island:'Santo'},
{village:'Loro',province:'Sanma',island:'Santo'},
{village:'Lorom',province:'Sanma',island:'Santo'},
{village:'Losal',province:'Sanma',island:'Santo'},
{village:'Losaraiolo',province:'Penama',island:'Ambae'},
{village:'Losarairisu',province:'Penama',island:'Ambae'},
{village:'Losaraivire',province:'Penama',island:'Ambae'},
{village:'Losaraivirewaga',province:'Penama',island:'Ambae'},
{village:'Losaraivulu',province:'Penama',island:'Ambae'},
{village:'Losova',province:'Sanma',island:'Santo'},
{village:'Lotahimamavi',province:'Penama',island:'Ambae'},
{village:'Lotalemba',province:'Penama',island:'Ambae'},
{village:'Lotandumindumi',province:'Penama',island:'Ambae'},
{village:'Lotawan',province:'Torba',island:'Mota'},
{village:'Lotawora',province:'Torba',island:'Mota'},
{village:'Lotoror',province:'Sanma',island:'Santo'},
{village:'Lovanualikoutu',province:'Penama',island:'Ambae'},
{village:'Lovanue',province:'Penama',island:'Ambae'},
{village:'Lovatmalava',province:'Penama',island:'Ambae'},
{village:'Lovatrukruk',province:'Penama',island:'Ambae'},
{village:'Lovatumemea',province:'Penama',island:'Ambae'},
{village:'Lovatuweliweli',province:'Penama',island:'Ambae'},
{village:'Loviakarkar',province:'Sanma',island:'Santo'},
{village:'Lovondakairue',province:'Penama',island:'Ambae'},
{village:'Lovotkar',province:'Sanma',island:'Santo'},
{village:'Lovuibanga',province:'Penama',island:'Ambae'},
{village:'Lovuibuge',province:'Penama',island:'Ambae'},
{village:'Lovuidao',province:'Penama',island:'Ambae'},
{village:'Lovuikatambola',province:'Penama',island:'Ambae'},
{village:'Lovuikevike',province:'Penama',island:'Ambae'},
{village:'Lovuimataboe',province:'Penama',island:'Ambae'},
{village:'Lovuimbaga',province:'Penama',island:'Ambae'},
{village:'Lovuimenagailolo',province:'Penama',island:'Ambae'},
{village:'Lovuinanara',province:'Penama',island:'Ambae'},
{village:'Lovuinove',province:'Penama',island:'Ambae'},
{village:'Lovuinvilli',province:'Penama',island:'Ambae'},
{village:'Lovuitogohui',province:'Penama',island:'Ambae'},
{village:'Lovuitungu',province:'Penama',island:'Ambae'},
{village:'Lovuivetu',province:'Penama',island:'Ambae'},
{village:'Lovunbise',province:'Penama',island:'Ambae'},
{village:'Lovunibanga',province:'Penama',island:'Ambae'},
{village:'Lovunibukevui',province:'Penama',island:'Ambae'},
{village:'Lovunieru',province:'Penama',island:'Ambae'},
{village:'Lovunikatambolo',province:'Penama',island:'Ambae'},
{village:'Lovunimangwe',province:'Penama',island:'Ambae'},
{village:'Lovunvili',province:'Penama',island:'Ambae'},
{village:'Lovusi',province:'Penama',island:'Ambae'},
{village:'Lovusi Kamalwei',province:'Penama',island:'Ambae'},
{village:'Lovusimala',province:'Penama',island:'Ambae'},
{village:'Lovusinava',province:'Penama',island:'Ambae'},
{village:'Lovusitarivue',province:'Penama',island:'Ambae'},
{village:'Lovutialau',province:'Penama',island:'Ambae'},
{village:'Lovutikerekere',province:'Penama',island:'Ambae'},
{village:'Lovutirovo',province:'Penama',island:'Ambae'},
{village:'Lovuvenu',province:'Sanma',island:'Santo'},
{village:'Lowainasasa',province:'Penama',island:'Ambae'},
{village:'Lowairoro',province:'Penama',island:'Ambae'},
{village:'Lowao',province:'Penama',island:'Pentecost'},
{village:'Lowotwot',province:'Sanma',island:'Santo'},
{village:'Luganville Cbd',province:'Sanma',island:'Santo'},
{village:'Lulu',province:'Sanma',island:'Malo'},
{village:'Lungharigi',province:'Torba',island:'Loh'},
{village:'Lutunai',province:'Sanma',island:'Santo'},
{village:'Mabenava',province:'Sanma',island:'Tutuba'},
{village:'Madas',province:'Penama',island:'Pentecost'},
{village:'Madong',province:'Penama',island:'Pentecost'},
{village:'Malao',province:'Sanma',island:'Santo'},
{village:'Malavuko',province:'Sanma',island:'Santo'},
{village:'Maliuviaji',province:'Sanma',island:'Santo'},
{village:'Maloeta',province:'Sanma',island:'Santo'},
{village:'Malokilikili',province:'Sanma',island:'Malokilikili'},
{village:'Malotau',province:'Sanma',island:'Santo'},
{village:'Malovira',province:'Sanma',island:'Santo'},
{village:'Mandiri',province:'Penama',island:'Maewo'},
{village:'Mango Station',province:'Sanma',island:'Santo'},
{village:'Mango Vara Clinic',province:'Sanma',island:'Santo'},
{village:'Marino',province:'Penama',island:'Maewo'},
{village:'Maritime College',province:'Sanma',island:'Santo'},
{village:'Mariu',province:'Torba',island:'Mota'},
{village:'Maroa',province:'Sanma',island:'Santo'},
{village:'Matafanga',province:'Torba',island:'Gaua'},
{village:'Mataindan',province:'Penama',island:'Ambae'},
{village:'Mataipevu',province:'Sanma',island:'Santo'},
{village:'Mataivura',province:'Sanma',island:'Santo'},
{village:'Matalip',province:'Sanma',island:'Santo'},
{village:'Mataloe',province:'Sanma',island:'Santo'},
{village:'Matamata',province:'Penama',island:'Ambae'},
{village:'Matantas',province:'Sanma',island:'Santo'},
{village:'Matanvuso',province:'Sanma',island:'Mavea'},
{village:'Mataravi',province:'Penama',island:'Ambae'},
{village:'Matbeiringi',province:'Penama',island:'Maewo'},
{village:'Matevulu College',province:'Sanma',island:'Santo'},
{village:'Maurep',province:'Penama',island:'Pentecost'},
{village:'Mavunlif',province:'Sanma',island:'Santo'},
{village:'Mbahurasumbe',province:'Sanma',island:'Malo'},
{village:'Mbeao',province:'Sanma',island:'Malo'},
{village:'Mberiot',province:'Torba',island:'Vanua Lava'},
{village:'Mbolorigi',province:'Penama',island:'Ambae'},
{village:'Mbwil',province:'Penama',island:'Pentecost'},
{village:'Melbulbul',province:'Sanma',island:'Malo'},
{village:'Melcoffee',province:'Sanma',island:'Santo'},
{village:'Melsisi',province:'Penama',island:'Pentecost'},
{village:'Merelaen',province:'Torba',island:'Vanua Lava'},
{village:'Metenemie',province:'Penama',island:'Pentecost'},
{village:'Metsalowon',province:'Torba',island:'Gaua'},
{village:'Miilion Dollar Pt',province:'Sanma',island:'Santo'},
{village:'Molpoi',province:'Sanma',island:'Santo'},
{village:'Mon Exil',province:'Sanma',island:'Santo'},
{village:'Morkiriv',province:'Sanma',island:'Santo'},
{village:'Moru Kari',province:'Sanma',island:'Santo'},
{village:'Mosina',province:'Torba',island:'Vanua Lava'},
{village:'Munhoro',province:'Torba',island:'Gaua'},
{village:'Munhuro',province:'Torba',island:'Gaua'},
{village:'Nabatului',province:'Sanma',island:'Malo'},
{village:'Nabekukwonge',province:'Penama',island:'Ambae'},
{village:'Nabiribiri',province:'Penama',island:'Ambae'},
{village:'Nabuluaru',province:'Sanma',island:'Santo'},
{village:'Nagole',province:'Penama',island:'Ambae'},
{village:'Nagolum',province:'Penama',island:'Pentecost'},
{village:'Nagoro',province:'Penama',island:'Maewo'},
{village:'Nagotambu',province:'Penama',island:'Ambae'},
{village:'Nagwea',province:'Penama',island:'Ambae'},
{village:'Nahala',province:'Penama',island:'Ambae'},
{village:'Nahorouta',province:'Sanma',island:'Malo'},
{village:'Najara',province:'Sanma',island:'Santo'},
{village:'Nakapakapa',province:'Penama',island:'Pentecost'},
{village:'Nakere',province:'Sanma',island:'Santo'},
{village:'Nalailani',province:'Sanma',island:'Santo'},
{village:'Naliliu',province:'Penama',island:'Ambae'},
{village:'Nalivukaivanua',province:'Sanma',island:'Malo'},
{village:'Namafun',province:'Sanma',island:'Santo'},
{village:'Namalo',province:'Sanma',island:'Santo'},
{village:'Namaram',province:'Penama',island:'Pentecost'},
{village:'Namarasama',province:'Penama',island:'Ambae'},
{village:'Namasarai',province:'Torba',island:'Gaua'},
{village:'Namavun',province:'Sanma',island:'Santo'},
{village:'Nambangahake',province:'Penama',island:'Ambae'},
{village:'Nambauk',province:'Sanma',island:'Santo'},
{village:'Nambel',province:'Sanma',island:'Santo'},
{village:'Namberukwonge',province:'Penama',island:'Ambae'},
{village:'Namberungwele',province:'Penama',island:'Ambae'},
{village:'Namboe',province:'Penama',island:'Ambae'},
{village:'Nambolankurusa',province:'Sanma',island:'Santo'},
{village:'Nambwarangiut',province:'Penama',island:'Pentecost'},
{village:'Namoru',province:'Sanma',island:'Santo'},
{village:'Namwele',province:'Sanma',island:'Malo'},
{village:'Nanako',province:'Penama',island:'Ambae'},
{village:'Nandiutu',province:'Sanma',island:'Malo'},
{village:'Nandunga',province:'Penama',island:'Maewo'},
{village:'Nangasa',province:'Sanma',island:'Malo'},
{village:'Nangweangwea',province:'Penama',island:'Ambae'},
{village:'Nanigama',province:'Penama',island:'Ambae'},
{village:'Nanivele',province:'Penama',island:'Ambae'},
{village:'Nanomb',province:'Sanma',island:'Santo'},
{village:'Nanuku',province:'Sanma',island:'Malo'},
{village:'Naomumu',province:'Penama',island:'Maewo'},
{village:'Naone (Maewo)',province:'Penama',island:'Maewo'},
{village:'Naone (Santo)',province:'Sanma',island:'Santo'},
{village:'Naonetas',province:'Sanma',island:'Santo'},
{village:'Naopona',province:'Sanma',island:'Mavea'},
{village:'Narada',province:'Sanma',island:'Santo'},
{village:'Narango (Santo)',province:'Sanma',island:'Santo'},
{village:'Narango 2 (Malo)',province:'Sanma',island:'Malo'},
{village:'Naravatu',province:'Penama',island:'Ambae'},
{village:'Narongleo',province:'Penama',island:'Ambae'},
{village:'Narovorovo',province:'Penama',island:'Maewo'},
{village:'Narua',province:'Sanma',island:'Santo'},
{village:'Narumaj',province:'Sanma',island:'Santo'},
{village:'Naruwa',province:'Penama',island:'Pentecost'},
{village:'Nasalakoro',province:'Penama',island:'Ambae'},
{village:'Nasawa',province:'Penama',island:'Maewo'},
{village:'Naseutora',province:'Penama',island:'Maewo'},
{village:'Nasulesule',province:'Sanma',island:'Santo'},
{village:'Natalu',province:'Penama',island:'Ambae'},
{village:'Nataluhangele',province:'Penama',island:'Ambae'},
{village:'Natanara',province:'Sanma',island:'Santo'},
{village:'Natanowaha',province:'Sanma',island:'Malo'},
{village:'Natawa',province:'Sanma',island:'Santo'},
{village:'Natchara',province:'Sanma',island:'Santo'},
{village:'Natui',province:'Sanma',island:'Santo'},
{village:'Natuleo',province:'Penama',island:'Ambae'},
{village:'Navakasara',province:'Penama',island:'Ambae'},
{village:'Navele',province:'Sanma',island:'Santo'},
{village:'Navenul',province:'Penama',island:'Pentecost'},
{village:'Navenvene',province:'Penama',island:'Maewo'},
{village:'Naveto',province:'Torba',island:'Gaua'},
{village:'Naviaru',province:'Sanma',island:'Malo'},
{village:'Naviaru Grn Kona',province:'Sanma',island:'Malo'},
{village:'Naviaru Grn Konam',province:'Sanma',island:'Malo'},
{village:'Naviova',province:'Sanma',island:'Malo'},
{village:'Naviso',province:'Penama',island:'Maewo'},
{village:'Navitora',province:'Penama',island:'Ambae'},
{village:'Navitora (Maewo)',province:'Penama',island:'Maewo'},
{village:'Navnaurota',province:'Sanma',island:'Santo'},
{village:'Navohovoho',province:'Penama',island:'Ambae'},
{village:'Navolala',province:'Sanma',island:'Santo'},
{village:'Navonda',province:'Penama',island:'Ambae'},
{village:'Navondavatu',province:'Sanma',island:'Malo'},
{village:'Navota Farm',province:'Sanma',island:'Santo'},
{village:'Navuti',province:'Sanma',island:'Santo'},
{village:'Navuturiki',province:'Penama',island:'Ambae'},
{village:'Nawalu',province:'Penama',island:'Ambae'},
{village:'Nawegu',province:'Penama',island:'Ambae'},
{village:'Nawelala',province:'Sanma',island:'Santo'},
{village:'Nawiambu',province:'Sanma',island:'Malo'},
{village:'Nduindui',province:'Penama',island:'Ambae'},
{village:'Nemeng',province:'Torba',island:'Gaua'},
{village:'Nemeng',province:'Torba',island:'Gaua'},
{village:'Nerenigman',province:'Torba',island:'Mota Lava'},
{village:'Ngere Gasal',province:'Torba',island:'Vanua Lava'},
{village:'Ngota',province:'Penama',island:'Maewo'},
{village:'Ngwarangaihaha',province:'Penama',island:'Ambae'},
{village:'Ngwataitora',province:'Penama',island:'Maewo'},
{village:'Ngwatangwele',province:'Penama',island:'Ambae'},
{village:'Ngwatiakwoli',province:'Penama',island:'Maewo'},
{village:'Ngwatumanu',province:'Penama',island:'Ambae'},
{village:'Ngwatvanua',province:'Penama',island:'Maewo'},
{village:'Niwi',province:'Penama',island:'Pentecost'},
{village:'Nokonbok',province:'Penama',island:'Pentecost'},
{village:'Nokonbongelan',province:'Penama',island:'Pentecost'},
{village:'Nokonbwa',province:'Penama',island:'Pentecost'},
{village:'Nokondavi',province:'Penama',island:'Pentecost'},
{village:'Nokonkaop',province:'Penama',island:'Pentecost'},
{village:'Nokonkulkul',province:'Penama',island:'Pentecost'},
{village:'Nokonraboga',province:'Penama',island:'Pentecost'},
{village:'Nokontangbwi',province:'Penama',island:'Pentecost'},
{village:'Nokontawen',province:'Penama',island:'Pentecost'},
{village:'Nokonwanet',province:'Penama',island:'Pentecost'},
{village:'Nokonwawos',province:'Penama',island:'Pentecost'},
{village:'Nokuku',province:'Sanma',island:'Santo'},
{village:'Nowo',province:'Torba',island:'Gaua'},
{village:'Nuwuk',province:'Penama',island:'Pentecost'},
{village:'Okoro',province:'Sanma',island:'Santo'},
{village:'Olmoh',province:'Penama',island:'Pentecost'},
{village:'Olpoi',province:'Sanma',island:'Santo'},
{village:'Onel',province:'Torba',island:'Gaua'},
{village:'Onlapa',province:'Penama',island:'Pentecost'},
{village:'Ontar',province:'Torba',island:'Gaua'},
{village:'Ororoi',province:'Sanma',island:'Santo'},
{village:'Orota',province:'Sanma',island:'Santo'},
{village:'Pagaruru',province:'Sanma',island:'Santo'},
{village:'Pakataora',province:'Sanma',island:'Santo'},
{village:'Palms Estate',province:'Sanma',island:'Santo'},
{village:'Palon',province:'Sanma',island:'Santo'},
{village:'Palone',province:'Sanma',island:'Santo'},
{village:'Panap',province:'Penama',island:'Pentecost'},
{village:'Panbanglap',province:'Penama',island:'Pentecost'},
{village:'Pangi',province:'Penama',island:'Pentecost'},
{village:'Panlimse',province:'Penama',island:'Pentecost'},
{village:'Pannas',province:'Penama',island:'Pentecost'},
{village:'Paparama',province:'Sanma',island:'Santo'},
{village:'Pareo',province:'Sanma',island:'Santo'},
{village:'Parisa',province:'Sanma',island:'Santo'},
{village:'Patui',province:'Sanma',island:'Santo'},
{village:'Patumbuma',province:'Sanma',island:'Tutuba'},
{village:'Peamaeto',province:'Sanma',island:'Santo'},
{village:'Peamatsina',province:'Sanma',island:'Santo'},
{village:'Peavot',province:'Sanma',island:'Santo'},
{village:'Pekoa Airport',province:'Sanma',island:'Santo'},
{village:'Pelmoli',province:'Sanma',island:'Santo'},
{village:'Pelvus',province:'Sanma',island:'Santo'},
{village:'Penaoru',province:'Sanma',island:'Santo'},
{village:'Peniel',province:'Sanma',island:'Santo'},
{village:'Peoke',province:'Sanma',island:'Santo'},
{village:'Pepsi',province:'Sanma',island:'Santo'},
{village:'Pepsi Bush',province:'Sanma',island:'Santo'},
{village:'Pesena',province:'Sanma',island:'Santo'},
{village:'Petani',province:'Sanma',island:'Santo'},
{village:'Petawata',province:'Sanma',island:'Santo'},
{village:'Peyrolles (Santo)',province:'Sanma',island:'Santo'},
{village:'Pialore',province:'Sanma',island:'Santo'},
{village:'Pialulup',province:'Sanma',island:'Santo'},
{village:'Picarde',province:'Sanma',island:'Aore'},
{village:'Pillion',province:'Sanma',island:'Santo'},
{village:'Pionas',province:'Sanma',island:'Santo'},
{village:'Pirao',province:'Sanma',island:'Santo'},
{village:'Plantation',province:'Sanma',island:'Santo'},
{village:'Poarou',province:'Sanma',island:'Santo'},
{village:'Poejiejie',province:'Sanma',island:'Santo'},
{village:'Point Cross',province:'Penama',island:'Pentecost'},
{village:'Pondum',province:'Sanma',island:'Santo'},
{village:'Ponov',province:'Penama',island:'Pentecost'},
{village:'Ponra',province:'Penama',island:'Pentecost'},
{village:'Port Olry',province:'Sanma',island:'Santo'},
{village:'Port Patterson',province:'Torba',island:'Vanua Lava'},
{village:'Potforo',province:'Sanma',island:'Santo'},
{village:'Potviar',province:'Sanma',island:'Santo'},
{village:'Powruru',province:'Penama',island:'Pentecost'},
{village:'Prospect',province:'Sanma',island:'Malo'},
{village:'Puama',province:'Sanma',island:'Santo'},
{village:'Puilovu',province:'Sanma',island:'Santo'},
{village:'Pump Station',province:'Sanma',island:'Santo'},
{village:'Qeremade',province:'Torba',island:'Mota Lava'},
{village:'Qetegaveg',province:'Torba',island:'Gaua'},
{village:'Qetevatevo',province:'Torba',island:'Gaua'},
{village:'Quanlap',province:'Torba',island:'Vanua Lava'},
{village:'Quantas',province:'Sanma',island:'Santo'},
{village:'Quatvaes',province:'Torba',island:'Vanua Lava'},
{village:'Radio Station',province:'Sanma',island:'Santo'},
{village:'Raflepa',province:'Sanma',island:'Santo'},
{village:'Rah',province:'Torba',island:'Rah'},
{village:'Ramwawat',province:'Penama',island:'Pentecost'},
{village:'Rangusuksuk',province:'Penama',island:'Pentecost'},
{village:'Ranliae',province:'Penama',island:'Pentecost'},
{village:'Ranliaie',province:'Penama',island:'Pentecost'},
{village:'Ranmawat',province:'Penama',island:'Pentecost'},
{village:'Ranputor',province:'Penama',island:'Pentecost'},
{village:'Ranru',province:'Penama',island:'Pentecost'},
{village:'Ranwadi',province:'Penama',island:'Pentecost'},
{village:'Ranwas',province:'Penama',island:'Pentecost'},
{village:'Ratard',province:'Sanma',island:'Santo'},
{village:'Raton',province:'Penama',island:'Pentecost'},
{village:'Ratua Island',province:'Sanma',island:'Aore'},
{village:'Red Corner',province:'Sanma',island:'Santo'},
{village:'Rembu',province:'Penama',island:'Maewo'},
{village:'Renbura',province:'Penama',island:'Pentecost'},
{village:'Reumanaboe',province:'Sanma',island:'Malo'},
{village:'Ribal',province:'Torba',island:'Metoma'},
{village:'Rinuha',province:'Torba',island:'Loh'},
{village:'Rockhill',province:'Penama',island:'Maewo'},
{village:'Rohoua',province:'Sanma',island:'Santo'},
{village:'Rongonawo',province:'Penama',island:'Maewo'},
{village:'Rotal',province:'Sanma',island:'Santo'},
{village:'Rowok',province:'Penama',island:'Pentecost'},
{village:'Saavat',province:'Penama',island:'Pentecost'},
{village:'Saenawar',province:'Penama',island:'Pentecost'},
{village:'Sakao',province:'Penama',island:'Ambae'},
{village:'Sakele',province:'Sanma',island:'Santo'},
{village:'Salaba',province:'Penama',island:'Pentecost'},
{village:'Salalia',province:'Sanma',island:'Santo'},
{village:'Salevakal',province:'Penama',island:'Pentecost'},
{village:'Sanapoe',province:'Sanma',island:'Malo'},
{village:'Sanmara',province:'Penama',island:'Pentecost'},
{village:'Santartara',province:'Sanma',island:'Mavea'},
{village:'Santo East',province:'Sanma',island:'Santo'},
{village:'Sapen',province:'Sanma',island:'Santo'},
{village:'Sara 1',province:'Sanma',island:'Santo'},
{village:'Sara 2',province:'Sanma',island:'Santo'},
{village:'Sara 3',province:'Sanma',island:'Santo'},
{village:'Sara Lokambu',province:'Penama',island:'Ambae'},
{village:'Sarabulu',province:'Penama',island:'Ambae'},
{village:'Saraibulo',province:'Penama',island:'Ambae'},
{village:'Sarailengwasa',province:'Penama',island:'Ambae'},
{village:'Saraingweto',province:'Penama',island:'Ambae'},
{village:'Sarairahu',province:'Penama',island:'Ambae'},
{village:'Sarairao',province:'Penama',island:'Ambae'},
{village:'Saraisese',province:'Penama',island:'Ambae'},
{village:'Saraivava',province:'Penama',island:'Ambae'},
{village:'Saraiverekasi',province:'Penama',island:'Ambae'},
{village:'Sarakata',province:'Sanma',island:'Santo'},
{village:'Sarakata Bridge',province:'Sanma',island:'Santo'},
{village:'Sarakokona',province:'Penama',island:'Ambae'},
{village:'Saralongwandu',province:'Penama',island:'Ambae'},
{village:'Saramahanga',province:'Penama',island:'Ambae'},
{village:'Sarami',province:'Sanma',island:'Santo'},
{village:'Saramoli',province:'Penama',island:'Ambae'},
{village:'Saranabuka',province:'Penama',island:'Ambae'},
{village:'Saranambuka',province:'Penama',island:'Ambae'},
{village:'Saranamundu',province:'Penama',island:'Ambae'},
{village:'Saranange',province:'Penama',island:'Ambae'},
{village:'Saranangwae',province:'Penama',island:'Ambae'},
{village:'Saranavihi',province:'Penama',island:'Ambae'},
{village:'Sarantari',province:'Penama',island:'Ambae'},
{village:'Saraotu',province:'Sanma',island:'Santo'},
{village:'Saratamata',province:'Penama',island:'Ambae'},
{village:'Saratangaulu',province:'Penama',island:'Ambae'},
{village:'Saravi/Sarabo',province:'Sanma',island:'Santo'},
{village:'Sarete',province:'Sanma',island:'Santo'},
{village:'Sarinlang',province:'Penama',island:'Pentecost'},
{village:'Saritangwata',province:'Penama',island:'Maewo'},
{village:'Sauriki',province:'Sanma',island:'Santo'},
{village:'Savakasa',province:'Sanma',island:'Malo'},
{village:'Sawalaba',province:'Penama',island:'Pentecost'},
{village:'Sawava',province:'Penama',island:'Maewo'},
{village:'Sda Mission',province:'Sanma',island:'Aore'},
{village:'Sele',province:'Sanma',island:'Santo'},
{village:'Sevoa',province:'Sanma',island:'Santo'},
{village:'Shark-Bay',province:'Sanma',island:'Santo'},
{village:'Shell',province:'Sanma',island:'Santo'},
{village:'Show Ground',province:'Sanma',island:'Santo'},
{village:'Side River',province:'Sanma',island:'Santo'},
{village:'Singmwel',province:'Penama',island:'Pentecost'},
{village:'Sirity',province:'Torba',island:'Gaua'},
{village:'Sisiol',province:'Torba',island:'Vanua Lava'},
{village:'Small Nanuhu',province:'Sanma',island:'Malo'},
{village:'Sola',province:'Torba',island:'Vanua Lava'},
{village:'Solkave',province:'Penama',island:'Ambae'},
{village:'Solomons Hill',province:'Sanma',island:'Santo'},
{village:'Solway',province:'Sanma',island:'Santo'},
{village:'Solway Plantation',province:'Sanma',island:'Santo'},
{village:'Sorowa',province:'Sanma',island:'Santo'},
{village:'St Michel',province:'Sanma',island:'Santo'},
{village:'Stone Hill',province:'Sanma',island:'Santo'},
{village:'Sulemaury',province:'Sanma',island:'Santo'},
{village:'Sulepe',province:'Sanma',island:'Santo'},
{village:'Sulesai',province:'Sanma',island:'Santo'},
{village:'Supemalao',province:'Sanma',island:'Santo'},
{village:'Suranda',province:'Sanma',island:'Santo'},
{village:'Taberan',province:'Penama',island:'Pentecost'},
{village:'Tabotalo',province:'Sanma',island:'Santo'},
{village:'Tabumbatu',province:'Sanma',island:'Tutuba'},
{village:'Tabuvoea',province:'Sanma',island:'Santo'},
{village:'Takaro (Lolovivuha)',province:'Penama',island:'Ambae'},
{village:'Tala',province:'Torba',island:'Gaua'},
{village:'Talatas',province:'Sanma',island:'Santo'},
{village:'Talise',province:'Penama',island:'Maewo'},
{village:'Talua',province:'Sanma',island:'Santo'},
{village:'Taluiere',province:'Sanma',island:'Santo'},
{village:'Talvavus',province:'Torba',island:'Gaua'},
{village:'Tam',province:'Penama',island:'Maewo'},
{village:'Tambotalo',province:'Sanma',island:'Santo'},
{village:'Tamburiamalao',province:'Sanma',island:'Tutuba'},
{village:'Tanarosa',province:'Torba',island:'Mota'},
{village:'Tanavoli',province:'Sanma',island:'Santo'},
{village:'Tanbok',province:'Penama',island:'Pentecost'},
{village:'Tancovu',province:'Sanma',island:'Santo'},
{village:'Tangisi',province:'Sanma',island:'Tangisi'},
{village:'Tangoa',province:'Sanma',island:'Tangoa'},
{village:'Tangwalulu',province:'Penama',island:'Maewo'},
{village:'Tankara',province:'Sanma',island:'Santo'},
{village:'Tankarang',province:'Penama',island:'Pentecost'},
{village:'Tanlap',province:'Torba',island:'Vanua Lava'},
{village:'Tanmaeto',province:'Penama',island:'Maewo'},
{village:'Tanmele',province:'Penama',island:'Pentecost'},
{village:'Tanmial (Malo)',province:'Sanma',island:'Malo'},
{village:'Tanoingwaro',province:'Penama',island:'Ambae'},
{village:'Tanovusivusi',province:'Sanma',island:'Santo'},
{village:'Tansip',province:'Penama',island:'Pentecost'},
{village:'Taona',province:'Sanma',island:'Tutuba'},
{village:'Taopevaro Pakalio (Nakrimel',province:'Sanma',island:'Santo'},
{village:'Taraibe',province:'Penama',island:'Pentecost'},
{village:'Tarasag',province:'Torba',island:'Gaua'},
{village:'Tasiriki (Santo)',province:'Sanma',island:'Santo'},
{village:'Tasmalum',province:'Sanma',island:'Santo'},
{village:'Tasman',province:'Torba',island:'Mere Lava'},
{village:'Tasmate (Santo)',province:'Sanma',island:'Santo'},
{village:'Tasmate(Mota)',province:'Torba',island:'Mota'},
{village:'Tasvarongo',province:'Penama',island:'Pentecost'},
{village:'Tatuve',province:'Torba',island:'Vanua Lava'},
{village:'Tavala',province:'Penama',island:'Ambae'},
{village:'Tavalangwala',province:'Penama',island:'Ambae'},
{village:'Tavalavusi',province:'Penama',island:'Ambae'},
{village:'Tavalavuti',province:'Penama',island:'Ambae'},
{village:'Tavali Gatama',province:'Penama',island:'Maewo'},
{village:'Tavolavola',province:'Penama',island:'Ambae'},
{village:'Tavorai',province:'Penama',island:'Pentecost'},
{village:'Tavugi',province:'Penama',island:'Ambae'},
{village:'Tavuine',province:'Sanma',island:'Santo'},
{village:'Tavunamalo',province:'Sanma',island:'Santo'},
{village:'Tavunapui',province:'Sanma',island:'Santo'},
{village:'Tawi Field',province:'Sanma',island:'Malo'},
{village:'Telaklak',province:'Torba',island:'Loh'},
{village:'Telvet',province:'Torba',island:'Mota Lava'},
{village:'Tetose',province:'Torba',island:'Hiu'},
{village:'Thalarev',province:'Sanma',island:'Santo'},
{village:'Timaru',province:'Torba',island:'Vanua Lava'},
{village:'Tino',province:'Torba',island:'Vanua Lava'},
{village:'Toas',province:'Penama',island:'Maewo'},
{village:'Toava',province:'Sanma',island:'Tutuba'},
{village:'Tole',province:'Penama',island:'Pentecost'},
{village:'Tolo',province:'Torba',island:'Gaua'},
{village:'Tolomako',province:'Sanma',island:'Santo'},
{village:'Toramauri',province:'Sanma',island:'Santo'},
{village:'Torgil',province:'Penama',island:'Ambae'},
{village:'Tosi',province:'Penama',island:'Pentecost'},
{village:'Totoglag',province:'Torba',island:'Mota Lava'},
{village:'Totokar',province:'Sanma',island:'Santo'},
{village:'Tovot',province:'Sanma',island:'Santo'},
{village:'Tovotovo',province:'Sanma',island:'Santo'},
{village:'Tsinbwege',province:'Penama',island:'Pentecost'},
{village:'Tuglata',province:'Penama',island:'Maewo'},
{village:'Tukwetap',province:'Torba',island:'Mota'},
{village:'Tumsisiro',province:'Penama',island:'Ambae'},
{village:'Turmele',province:'Sanma',island:'Santo'},
{village:'Turtle Bay',province:'Sanma',island:'Santo'},
{village:'Tuturu',province:'Sanma',island:'Santo'},
{village:'Umulongo',province:'Penama',island:'Maewo'},
{village:'Unvene',province:'Penama',island:'Pentecost'},
{village:'Urav',province:'Sanma',island:'Santo'},
{village:'Urembulu',province:'Penama',island:'Ambae'},
{village:'Urewerep',province:'Penama',island:'Pentecost'},
{village:'Vaerani',province:'Sanma',island:'Santo'},
{village:'Vaiwos',province:'Penama',island:'Pentecost'},
{village:'Valankara',province:'Sanma',island:'Santo'},
{village:'Valapei',province:'Sanma',island:'Santo'},
{village:'Valavalet',province:'Sanma',island:'Santo'},
{village:'Valpei',province:'Sanma',island:'Santo'},
{village:'Valuwa',province:'Torba',island:'Mota Lava'},
{village:'Vanaar',province:'Penama',island:'Pentecost'},
{village:'Vanaia',province:'Penama',island:'Pentecost'},
{village:'Vanbak',province:'Penama',island:'Pentecost'},
{village:'Vanbanamel',province:'Penama',island:'Pentecost'},
{village:'Vanbwarus',province:'Penama',island:'Pentecost'},
{village:'Vandue',province:'Penama',island:'Ambae'},
{village:'Vanguru',province:'Penama',island:'Pentecost'},
{village:'Vanis',province:'Penama',island:'Pentecost'},
{village:'Vankaviala',province:'Penama',island:'Pentecost'},
{village:'Vanmelang',province:'Penama',island:'Pentecost'},
{village:'Vanmwelamwela',province:'Penama',island:'Pentecost'},
{village:'Vanraba',province:'Penama',island:'Pentecost'},
{village:'Vanrasini',province:'Penama',island:'Pentecost'},
{village:'Vanrewerep',province:'Penama',island:'Pentecost'},
{village:'Vansasa',province:'Penama',island:'Pentecost'},
{village:'Vansede',province:'Penama',island:'Pentecost'},
{village:'Vansemwakul',province:'Penama',island:'Pentecost'},
{village:'Vanuakam',province:'Penama',island:'Pentecost'},
{village:'Vanvalkaro',province:'Penama',island:'Pentecost'},
{village:'Vanvat',province:'Penama',island:'Pentecost'},
{village:'Vanwaknasimo',province:'Penama',island:'Pentecost'},
{village:'Vanwoki',province:'Penama',island:'Pentecost'},
{village:'Vapepoi',province:'Sanma',island:'Malo'},
{village:'Varabwa',province:'Penama',island:'Pentecost'},
{village:'Variwirip',province:'Penama',island:'Pentecost'},
{village:'Varsare',province:'Penama',island:'Pentecost'},
{village:'Vartc Plantation',province:'Sanma',island:'Santo'},
{village:'Vasalal',province:'Penama',island:'Pentecost'},
{village:'Vasalea',province:'Sanma',island:'Santo'},
{village:'Vasba',province:'Penama',island:'Pentecost'},
{village:'Vasi',province:'Sanma',island:'Santo'},
{village:'Vatkwari',province:'Penama',island:'Maewo'},
{village:'Vatlis',province:'Torba',island:'Gaua'},
{village:'Vatop',province:'Torba',island:'Vanua Lava'},
{village:'Vatrata',province:'Torba',island:'Vanua Lava'},
{village:'Vatsare',province:'Penama',island:'Pentecost'},
{village:'Vatuanga (West Ambae)',province:'Penama',island:'Ambae'},
{village:'Vavavia',province:'Sanma',island:'Santo'},
{village:'Vavuro',province:'Sanma',island:'Santo'},
{village:'Vawoor',province:'Penama',island:'Pentecost'},
{village:'Venue',province:'Sanma',island:'Santo'},
{village:'Verue',province:'Penama',island:'Maewo'},
{village:'Vetroworok',province:'Penama',island:'Pentecost'},
{village:'Vetuboso',province:'Torba',island:'Vanua Lava'},
{village:'Veverao',province:'Torba',island:'Mota'},
{village:'Viavoj',province:'Sanma',island:'Santo'},
{village:'Vilakalaka',province:'Penama',island:'Ambae'},
{village:'Vilausu',province:'Sanma',island:'Santo'},
{village:'Vilel',province:'Penama',island:'Pentecost'},
{village:'Vilvil',province:'Sanma',island:'Santo'},
{village:'Vimala',province:'Sanma',island:'Santo'},
{village:'Vinambulu',province:'Penama',island:'Ambae'},
{village:'Vinangwangwe',province:'Penama',island:'Ambae'},
{village:'Vinobuma',province:'Sanma',island:'Mavea'},
{village:'Violas',province:'Sanma',island:'Santo'},
{village:'Viorloko',province:'Sanma',island:'Santo'},
{village:'Vipue',province:'Sanma',island:'Santo'},
{village:'Visio',province:'Sanma',island:'Santo'},
{village:'Vologigia',province:'Sanma',island:'Santo'},
{village:'Vorovoke',province:'Sanma',island:'Santo'},
{village:'Vuimangwetoli',province:'Penama',island:'Ambae'},
{village:'Vuimberugu',province:'Penama',island:'Ambae'},
{village:'Vuingalato',province:'Penama',island:'Ambae'},
{village:'Vunabisu',province:'Sanma',island:'Santo'},
{village:'Vunalevu',province:'Sanma',island:'Santo'},
{village:'Vunamalae',province:'Sanma',island:'Tutuba'},
{village:'Vunamarivu',province:'Sanma',island:'Santo'},
{village:'Vunap',province:'Sanma',island:'Santo'},
{village:'Vunapisu',province:'Sanma',island:'Santo'},
{village:'Vunarei',province:'Sanma',island:'Santo'},
{village:'Vunasari',province:'Sanma',island:'Tutuba'},
{village:'Vunaus',province:'Sanma',island:'Santo'},
{village:'Vunavosi',province:'Sanma',island:'Santo'},
{village:'Vunmatal',province:'Sanma',island:'Santo'},
{village:'Vupuelolo',province:'Sanma',island:'Santo'},
{village:'Vuravuraepohi',province:'Sanma',island:'Santo'},
{village:'Vusiroro',province:'Sanma',island:'Santo'},
{village:'Vustumtum',province:'Sanma',island:'Santo'},
{village:'Vusvango',province:'Sanma',island:'Santo'},
{village:'Vutioro',province:'Sanma',island:'Santo'},
{village:'Vutkara',province:'Sanma',island:'Santo'},
{village:'Wading',province:'Penama',island:'Pentecost'},
{village:'Wadomaba',province:'Penama',island:'Pentecost'},
{village:'Wadungmwaba',province:'Penama',island:'Pentecost'},
{village:'Waet Wota',province:'Penama',island:'Pentecost'},
{village:'Waidumi',province:'Penama',island:'Ambae'},
{village:'Wailapa',province:'Sanma',island:'Santo'},
{village:'Wailengi',province:'Penama',island:'Ambae'},
{village:'Waisine',province:'Penama',island:'Ambae'},
{village:'Waisoho',province:'Penama',island:'Maewo'},
{village:'Walaha',province:'Penama',island:'Ambae'},
{village:'Wali',province:'Penama',island:'Pentecost'},
{village:'Waluriki',province:'Penama',island:'Ambae'},
{village:'Wambalao',province:'Sanma',island:'Malo'},
{village:'Wanbukelan',province:'Penama',island:'Pentecost'},
{village:'Wanlegok',province:'Penama',island:'Pentecost'},
{village:'Wansa',province:'Penama',island:'Pentecost'},
{village:'Wanur',province:'Penama',island:'Pentecost'},
{village:'Wasak',province:'Penama',island:'Pentecost'},
{village:'White Grass (Santo)',province:'Sanma',island:'Santo'},
{village:'Winsao',province:'Sanma',island:'Santo'},
{village:'Wolingan',province:'Penama',island:'Pentecost'},
{village:'Wong Plantation',province:'Sanma',island:'Santo'},
{village:'Wosaga',province:'Torba',island:'Vanua Lava'},
{village:'Wosayolo',province:'Sanma',island:'Santo'},
{village:'Wotip',province:'Penama',island:'Pentecost'},
{village:'Wujunmwel',province:'Penama',island:'Pentecost'},
{village:'Wumeram',province:'Penama',island:'Pentecost'},
{village:'Wunapak',province:'Sanma',island:'Santo'},
{village:'Wunaray',province:'Sanma',island:'Santo'},
{village:'Wunavae',province:'Sanma',island:'Santo'},
{village:'Wunmeleus',province:'Sanma',island:'Santo'},
{village:'Wunon',province:'Sanma',island:'Santo'},
{village:'Wunpuku',province:'Sanma',island:'Santo'},
{village:'Wusi',province:'Sanma',island:'Santo'},
{village:'Yekar',province:'Sanma',island:'Santo'},
{village:'Yeugavigamena',province:'Torba',island:'Hiu'},
{village:'Yoawoyea',province:'Torba',island:'Hiu'},
{village:'Yokwana',province:'Torba',island:'Hiu'},
{village:'Yora',province:'Sanma',island:'Santo'},
{village:'Torman',province:'Malampa',island:'Malekula'},
{village:'Nambatu Lagoon',province:'Shefa',island:'Efate'},
{village:'Agathis',province:'Shefa',island:'Efate'},
{village:'Ahaj',province:'Tafea',island:'Aneityum'},
{village:'Umeij',province:'Tafea',island:'Aneityum'},
{village:'Aim',province:'Malampa',island:'Norsup'},
{village:'Penbahur',province:'Malampa',island:'Akhamb'},
{village:'Aktep',province:'Malampa',island:'Malekula'},
{village:'Alak',province:'Shefa',island:'Epi'},
{village:'Alavas',province:'Malampa',island:'Malekula'},
{village:'Albatei',province:'Malampa',island:'Malekula'},
{village:'Alemtu',province:'Malampa',island:'Malekula'},
{village:'Alkakau',province:'Malampa',island:'Malekula'},
{village:'Alnawirir',province:'Malampa',island:'Malekula'},
{village:'Amaro',province:'Shefa',island:'Epi'},
{village:'Amaua',province:'Shefa',island:'Efate'},
{village:'Lembinwen',province:'Malampa',island:'Malekula'},
{village:'Amelaten',province:'Malampa',island:'Malekula'},
{village:'Ameli',province:'Malampa',island:'Malekula'},
{village:'Amelvet',province:'Malampa',island:'Malekula'},
{village:'Amplithei',province:'Tafea',island:'Aneityum'},
{village:'Uwonmohoc',province:'Tafea',island:'Aneityum'},
{village:'Anadwei',province:'Tafea',island:'Aneityum'},
{village:'Anagye',province:'Tafea',island:'Aneityum'},
{village:'Annaiya',province:'Tafea',island:'Aneityum'},
{village:'Anuwunampaku',province:'Tafea',island:'Aneityum'},
{village:'Aname',province:'Tafea',island:'Aneityum'},
{village:'Anap',province:'Malampa',island:'Malekula'},
{village:'Anatuni',province:'Tafea',island:'Aneityum'},
{village:'Anauamet',province:'Tafea',island:'Aneityum'},
{village:'Anawanjei',province:'Tafea',island:'Aneityum'},
{village:'Anawonse',province:'Tafea',island:'Aneityum'},
{village:'Anduan',province:'Shefa',island:'Epi'},
{village:'Anekelcap',province:'Tafea',island:'Aneityum'},
{village:'Anelgowhat',province:'Tafea',island:'Aneityum'},
{village:'Anelluhu',province:'Tafea',island:'Aneityum'},
{village:'Anijkei',province:'Tafea',island:'Aneityum'},
{village:'Anisinecen',province:'Tafea',island:'Aneityum'},
{village:'Anlas',province:'Tafea',island:'Aneityum'},
{village:'Annarico',province:'Tafea',island:'Aneityum'},
{village:'Anowunamlao',province:'Tafea',island:'Aneityum'},
{village:'Anoyac',province:'Tafea',island:'Aneityum'},
{village:'Antanapeing',province:'Tafea',island:'Aneityum'},
{village:'Antap',province:'Tafea',island:'Aneityum'},
{village:'Antaspos',province:'Tafea',island:'Aneityum'},
{village:'Antidu',province:'Tafea',island:'Aneityum'},
{village:'Antioch',province:'Tafea',island:'Erromango'},
{village:'Anuatakh',province:'Malampa',island:'Malekula'},
{village:'Anwaj',province:'Tafea',island:'Aneityum'},
{village:'Anwucei',province:'Tafea',island:'Aneityum'},
{village:'Aout Veil',province:'Malampa',island:'Malekula'},
{village:'Aplamituamk',province:'Malampa',island:'Malekula'},
{village:'Areuv',province:'Malampa',island:'Avokh'},
{village:'Arun',province:'Malampa',island:'Malekula'},
{village:'Ase',province:'Malampa',island:'Ambrym'},
{village:'Asurk',province:'Malampa',island:'Malekula'},
{village:'Assen',province:'Malampa',island:'Malekula'},
{village:'Asuruhk',province:'Malampa',island:'Malekula'},
{village:'Asurukh',province:'Malampa',island:'Malekula'},
{village:'Atan',province:'Malampa',island:'Norsup'},
{village:'Aulua',province:'Malampa',island:'Malekula'},
{village:'Autof',province:'Malampa',island:'Malekula'},
{village:'Avock',province:'Malampa',island:'Avokh'},
{village:'Beshak',province:'Malampa',island:'Ambrym'},
{village:'Baiap',province:'Malampa',island:'Ambrym'},
{village:'Pamante',province:'Shefa',island:'Epi'},
{village:'Banam Bay',province:'Malampa',island:'Malekula'},
{village:'Banana Bay',province:'Shefa',island:'Efate'},
{village:'Banga',province:'Shefa',island:'Epi'},
{village:'Panlenum',province:'Malampa',island:'Ambrym'},
{village:'Parmar',province:'Malampa',island:'Malekula'},
{village:'Bareas',province:'Malampa',island:'Malekula'},
{village:'Baree',province:'Malampa',island:'Malekula'},
{village:'Barias',province:'Malampa',island:'Malekula'},
{village:'Barmandrin',province:'Malampa',island:'Malekula'},
{village:'Batambong',province:'Malampa',island:'Malekula'},
{village:'Batambu',province:'Malampa',island:'Malekula'},
{village:'Batboy',province:'Malampa',island:'Malekula'},
{village:'Batekfaev',province:'Malampa',island:'Malekula'},
{village:'Behaltalam',province:'Malampa',island:'Ambrym'},
{village:'Pelsy',province:'Sanma',island:'Santo'},
{village:'Bellview (inc. Bellview Park)',province:'Shefa',island:'Efate'},
{village:'Benal',province:'Malampa',island:'Malekula'},
{village:'Benat',province:'Malampa',island:'Ambrym'},
{village:'Beneghai',province:'Malampa',island:'Malekula'},
{village:'Mulohol',province:'Shefa',island:'Buninga'},
{village:'Beneur',province:'Malampa',island:'Malekula'},
{village:'Endu Poal',province:'Malampa',island:'Ambrym'},
{village:'Betehul',province:'Malampa',island:'Vao'},
{village:'Beterihi',province:'Malampa',island:'Vao'},
{village:'Bethel (Malekula)',province:'Malampa',island:'Malekula'},
{village:'Bethel (Tanna)',province:'Tafea',island:'Tanna'},
{village:'Betuwal',province:'Malampa',island:'Malekula'},
{village:'Beverly Hills',province:'Shefa',island:'Efate'},
{village:'Bible School',province:'Malampa',island:'Malekula'},
{village:'Big Tautu',province:'Malampa',island:'Malekula'},
{village:'Blacksands (Efate)',province:'Shefa',island:'Efate'},
{village:'Blacksands (Malekula)',province:'Malampa',island:'Malekula'},
{village:'Bladiniere Estate',province:'Shefa',island:'Efate'},
{village:'Port Quime',province:'Shefa',island:'Epi'},
{village:'Blue Water Island Resort',province:'Shefa',island:'Efate'},
{village:'Lamap',province:'Malampa',island:'Malekula'},
{village:'Botndaso',province:'Shefa',island:'Epi'},
{village:'Coldwater',province:'Shefa',island:'Epi'},
{village:'Bogor',province:'Malampa',island:'Ambrym'},
{village:'Bolegaomiele',province:'Malampa',island:'Malekula'},
{village:'Enmila',province:'Malampa',island:'Ambrym'},
{village:'Boliko',province:'Malampa',island:'Ambrym'},
{village:'Ravolvert',province:'Malampa',island:'Ambrym'},
{village:'Bongabonga',province:'Shefa',island:'Tongoa'},
{village:'Tamsel',province:'Tafea',island:'Erromango'},
{village:'Bonoka',province:'Shefa',island:'Epi'},
{village:'Bonvor',province:'Malampa',island:'Malekula'},
{village:'Borabora',province:'Sanma',island:'Santo'},
{village:'Bosao',province:'Shefa',island:'Epi'},
{village:'Botolvo',province:'Malampa',island:'Malekula'},
{village:'Botovoro',province:'Malampa',island:'Malekula'},
{village:'Botuai',province:'Shefa',island:'Emae'},
{village:'Boueboue',province:'Shefa',island:'Epi'},
{village:'Bouffa',province:'Shefa',island:'Efate'},
{village:'Boukaliu',province:'Shefa',island:'Efate'},
{village:'Breha',province:'Malampa',island:'Malekula'},
{village:'Brenwei',province:'Malampa',island:'Malekula'},
{village:'Brisbane (Akhamb)',province:'Malampa',island:'Akhamb'},
{village:'Burumba',province:'Shefa',island:'Epi'},
{village:'Bukura',province:'Shefa',island:'Efate'},
{village:'Buleavepipio',province:'Malampa',island:'Ambrym'},
{village:'Loar',province:'Shefa',island:'Epi'},
{village:'Prilmalko',province:'Shefa',island:'Epi'},
{village:'Bulutuwukorkor',province:'Malampa',island:'Ambrym'},
{village:'Buluwike Bwewis',province:'Malampa',island:'Ambrym'},
{village:'Bungavus',province:'Malampa',island:'Malekula'},
{village:'Buniakup',province:'Tafea',island:'Erromango'},
{village:'Port Vato',province:'Malampa',island:'Ambrym'},
{village:'Bur',province:'Malampa',island:'Malekula'},
{village:'Burao',province:'Shefa',island:'Tongoa'},
{village:'Buraoloa',province:'Shefa',island:'Efate'},
{village:'Burbar',province:'Malampa',island:'Malekula'},
{village:'Burtumar',province:'Shefa',island:'Epi'},
{village:'Bushman\'S Bay',province:'Malampa',island:'Malekula'},
{village:'Bwele',province:'Malampa',island:'Ambrym'},
{village:'Chicken City',province:'Shefa',island:'Efate'},
{village:'Chumasmoe',province:'Shefa',island:'Epi'},
{village:'Evergreen',province:'Shefa',island:'Efate'},
{village:'Clear River',province:'Malampa',island:'Malekula'},
{village:'Club Hippique (Erakor)',province:'Shefa',island:'Efate'},
{village:'Club Hippique (Eratap)',province:'Shefa',island:'Efate'},
{village:'Sisle',province:'Malampa',island:'Malekula'},
{village:'Danperper',province:'Malampa',island:'Malekula'},
{village:'Devil\'S Point',province:'Shefa',island:'Efate'},
{village:'Dip Point',province:'Tafea',island:'Tanna'},
{village:'Dixon Reef',province:'Malampa',island:'Malekula'},
{village:'Dravai',province:'Malampa',island:'Malekula'},
{village:'Edejen',province:'Tafea',island:'Aneityum'},
{village:'Efalefale',province:'Shefa',island:'Efate'},
{village:'Ikaokao',province:'Tafea',island:'Aniwa'},
{village:'Ekipe',province:'Shefa',island:'Efate'},
{village:'Erakor Haf Rod',province:'Shefa',island:'Efate'},
{village:'Eliu',province:'Shefa',island:'Epi'},
{village:'Ellouk',province:'Shefa',island:'Efate'},
{village:'Elnisi',province:'Malampa',island:'Malekula'},
{village:'Elu',province:'Malampa',island:'Malekula'},
{village:'Emanam',province:'Tafea',island:'Tanna'},
{village:'Emanie R',province:'Tafea',island:'Tanna'},
{village:'Mak Erakor Hafrod',province:'Shefa',island:'Efate'},
{village:'Club Hippique',province:'Shefa',island:'Efate'},
{village:'Emua',province:'Shefa',island:'Efate'},
{village:'Enalngunia',province:'Tafea',island:'Tanna'},
{village:'Enam',province:'Shefa',island:'Efate'},
{village:'Enamel',province:'Tafea',island:'Tanna'},
{village:'Enaola',province:'Tafea',island:'Tanna'},
{village:'Enauhrat',province:'Tafea',island:'Tanna'},
{village:'Yenaohia',province:'Tafea',island:'Tanna'},
{village:'Enawra',province:'Tafea',island:'Tanna'},
{village:'Enbaraben',province:'Tafea',island:'Tanna'},
{village:'Melektree',province:'Shefa',island:'Efate'},
{village:'Enegam',province:'Tafea',island:'Tanna'},
{village:'Enfitana',province:'Tafea',island:'Tanna'},
{village:'Eniai',province:'Tafea',island:'Tanna'},
{village:'Enima',province:'Tafea',island:'Tanna'},
{village:'Enimb',province:'Malampa',island:'Malekula'},
{village:'Eniu',province:'Tafea',island:'Tanna'},
{village:'Enkatele',province:'Tafea',island:'Tanna'},
{village:'Enma Tangi',province:'Tafea',island:'Tanna'},
{village:'Enpek Lapen',province:'Tafea',island:'Tanna'},
{village:'Entauat',province:'Tafea',island:'Tanna'},
{village:'Likon',province:'Malampa',island:'Ambrym'},
{village:'Enuaker',province:'Tafea',island:'Tanna'},
{village:'Yakwariteng',province:'Tafea',island:'Tanna'},
{village:'Envere',province:'Malampa',island:'Ambrym'},
{village:'Epao',province:'Shefa',island:'Efate'},
{village:'Epule',province:'Shefa',island:'Efate'},
{village:'Erakor',province:'Shefa',island:'Efate'},
{village:'Erakor Bridge',province:'Shefa',island:'Efate'},
{village:'Malapoa Estate',province:'Shefa',island:'Efate'},
{village:'Erangorango',province:'Shefa',island:'Efate'},
{village:'Erata',province:'Shefa',island:'Tongariki'},
{village:'Eratap',province:'Shefa',island:'Efate'},
{village:'Eratap Hafrod',province:'Shefa',island:'Efate'},
{village:'Eripos',province:'Malampa',island:'Wala'},
{village:'Ernas',province:'Shefa',island:'Efate'},
{village:'Erueti',province:'Shefa',island:'Efate'},
{village:'Etanagie',province:'Tafea',island:'Aneityum'},
{village:'Etas',province:'Shefa',island:'Efate'},
{village:'Etaslep (Erakor Haf Rod)',province:'Shefa',island:'Efate'},
{village:'Ethaul',province:'Tafea',island:'Tanna'},
{village:'Ethvarei',province:'Tafea',island:'Aneityum'},
{village:'Eton',province:'Shefa',island:'Efate'},
{village:'Etong',province:'Malampa',island:'Ambrym'},
{village:'Euta',province:'Shefa',island:'Tongoa'},
{village:'Melemaat',province:'Shefa',island:'Efate'},
{village:'Ewu',province:'Malampa',island:'Ambrym'},
{village:'Teouma Garden',province:'Shefa',island:'Efate'},
{village:'Fali',province:'Malampa',island:'Ambrym'},
{village:'Falibour',province:'Malampa',island:'Ambrym'},
{village:'Faliwa',province:'Malampa',island:'Ambrym'},
{village:'Fanla',province:'Malampa',island:'Ambrym'},
{village:'Fanrereo',province:'Malampa',island:'Ambrym'},
{village:'Fansar',province:'Malampa',island:'Ambrym'},
{village:'Fantan',province:'Malampa',island:'Ambrym'},
{village:'Fantcheveur',province:'Malampa',island:'Ambrym'},
{village:'Fantongtong',province:'Malampa',island:'Ambrym'},
{village:'Lonlililiu',province:'Malampa',island:'Ambrym'},
{village:'Faralo',province:'Malampa',island:'Malekula'},
{village:'Faramenmenkonkon',province:'Malampa',island:'Ambrym'},
{village:'Faramsu',province:'Malampa',island:'Ambrym'},
{village:'Faraptawonwon',province:'Malampa',island:'Ambrym'},
{village:'Farapupol',province:'Malampa',island:'Ambrym'},
{village:'Rewoka Napua',province:'Shefa',island:'Nguna'},
{village:'Farealapa',province:'Shefa',island:'Nguna'},
{village:'Fartavo',province:'Malampa',island:'Malekula'},
{village:'Farun',province:'Malampa',island:'Malekula'},
{village:'Fatarapa',province:'Tafea',island:'Tanna'},
{village:'Fatima',province:'Malampa',island:'Malekula'},
{village:'Fetukai',province:'Tafea',island:'Tanna'},
{village:'Filakara',province:'Shefa',island:'Epi'},
{village:'Filmbil',province:'Malampa',island:'Malekula'},
{village:'Finonge',province:'Shefa',island:'Emae'},
{village:'Flat',province:'Sanma',island:'Santo'},
{village:'Fona',province:'Malampa',island:'Ambrym'},
{village:'Fonmur',province:'Malampa',island:'Ambrym'},
{village:'Fonteng',province:'Malampa',island:'Ambrym'},
{village:'Forari',province:'Shefa',island:'Efate'},
{village:'Foreland',province:'Shefa',island:'Epi'},
{village:'Nazareth (Epi)',province:'Shefa',island:'Epi'},
{village:'Forty Three',province:'Malampa',island:'Malekula'},
{village:'Fotinweiu',province:'Malampa',island:'Malekula'},
{village:'Freddy\'S Community',province:'Malampa',island:'Malekula'},
{village:'Freshwater',province:'Shefa',island:'Epi'},
{village:'Freswota 1',province:'Shefa',island:'Efate'},
{village:'Freswota 2',province:'Shefa',island:'Efate'},
{village:'Freswota 3',province:'Shefa',island:'Efate'},
{village:'Freswota 4',province:'Shefa',island:'Efate'},
{village:'Freswota 5',province:'Shefa',island:'Efate'},
{village:'Freswota 6',province:'Shefa',island:'Efate'},
{village:'Galili',province:'Malampa',island:'Malekula'},
{village:'Vila Town (Cbd)',province:'Shefa',island:'Efate'},
{village:'Ginonarong',province:'Malampa',island:'Malekula'},
{village:'Ipota',province:'Tafea',island:'Erromango'},
{village:'Green Cove',province:'Shefa',island:'Efate'},
{village:'Green Hill',province:'Shefa',island:'Epi'},
{village:'Green Point',province:'Tafea',island:'Tanna'},
{village:'Teouma Green Hill',province:'Shefa',island:'Efate'},
{village:'Hydro',province:'Sanma',island:'Santo'},
{village:'Halhal Taworo',province:'Malampa',island:'Ambrym'},
{village:'Harimal',province:'Malampa',island:'Ambrym'},
{village:'Hatbol',province:'Malampa',island:'Malekula'},
{village:'Hebron',province:'Tafea',island:'Tanna'},
{village:'Hemerdabos',province:'Malampa',island:'Malekula'},
{village:'Hemertabos',province:'Malampa',island:'Malekula'},
{village:'Hideaway Island',province:'Shefa',island:'Hideaway'},
{village:'High Hill',province:'Tafea',island:'Tanna'},
{village:'Hingal',province:'Malampa',island:'Paama'},
{village:'Hirang',province:'Malampa',island:'Malekula'},
{village:'Hokai',province:'Malampa',island:'Malekula'},
{village:'Hone',province:'Malampa',island:'Malekula'},
{village:'Iakel',province:'Tafea',island:'Tanna'},
{village:'Iakumeapsen',province:'Tafea',island:'Tanna'},
{village:'Iamravang',province:'Tafea',island:'Tanna'},
{village:'Ianapai',province:'Tafea',island:'Tanna'},
{village:'Ianarao',province:'Tafea',island:'Tanna'},
{village:'Ianemra',province:'Tafea',island:'Tanna'},
{village:'Ianfulia',province:'Tafea',island:'Tanna'},
{village:'Iankwa Nenpek',province:'Tafea',island:'Tanna'},
{village:'Iansip',province:'Tafea',island:'Tanna'},
{village:'Ianuak',province:'Tafea',island:'Tanna'},
{village:'Ianumnawa',province:'Tafea',island:'Tanna'},
{village:'Ianumta',province:'Tafea',island:'Tanna'},
{village:'Iapangnava',province:'Tafea',island:'Tanna'},
{village:'Iapnamal',province:'Tafea',island:'Tanna'},
{village:'Iapnoutaling',province:'Tafea',island:'Tanna'},
{village:'Yankwa Netatna',province:'Tafea',island:'Tanna'},
{village:'Iarkei',province:'Tafea',island:'Tanna'},
{village:'Iasoa',province:'Tafea',island:'Futuna'},
{village:'Iatap',province:'Tafea',island:'Tanna'},
{village:'Iatukuri',province:'Tafea',island:'Tanna'},
{village:'Iaueru',province:'Tafea',island:'Tanna'},
{village:'Ienepir',province:'Tafea',island:'Tanna'},
{village:'Ienfitana',province:'Tafea',island:'Tanna'},
{village:'Ienkuru',province:'Tafea',island:'Tanna'},
{village:'Iepilmail',province:'Tafea',island:'Tanna'},
{village:'Ifa',province:'Tafea',island:'Tanna'},
{village:'Ifangawe',province:'Tafea',island:'Aniwa'},
{village:'Ifira',province:'Shefa',island:'Efate'},
{village:'Ifo',province:'Tafea',island:'Erromango'},
{village:'Ihilcou',province:'Tafea',island:'Aneityum'},
{village:'Ihlareng',province:'Tafea',island:'Tanna'},
{village:'Monga Ehluga',province:'Tafea',island:'Futuna'},
{village:'Ijases',province:'Tafea',island:'Aneityum'},
{village:'Ikalev',province:'Tafea',island:'Tanna'},
{village:'Ikaoras',province:'Tafea',island:'Tanna'},
{village:'Ikapow',province:'Tafea',island:'Tanna'},
{village:'Ikiakis',province:'Tafea',island:'Tanna'},
{village:'Ikiti',province:'Tafea',island:'Tanna'},
{village:'Ikiyo',province:'Tafea',island:'Tanna'},
{village:'Ikunakut',province:'Tafea',island:'Tanna'},
{village:'Ikunala',province:'Tafea',island:'Tanna'},
{village:'Ikunap',province:'Tafea',island:'Tanna'},
{village:'Ikunara',province:'Tafea',island:'Tanna'},
{village:'Yekunauka',province:'Tafea',island:'Tanna'},
{village:'Ikunuingen',province:'Tafea',island:'Tanna'},
{village:'Ikurakau',province:'Tafea',island:'Tanna'},
{village:'Ikurakus',province:'Tafea',island:'Tanna'},
{village:'Ikurup',province:'Tafea',island:'Tanna'},
{village:'Ikutengteng',province:'Tafea',island:'Tanna'},
{village:'Ikutuhmien',province:'Tafea',island:'Tanna'},
{village:'Ikwipir',province:'Tafea',island:'Tanna'},
{village:'Ili',province:'Malampa',island:'Malekula'},
{village:'Ilifou',province:'Tafea',island:'Tanna'},
{village:'Ilisilis',province:'Tafea',island:'Tanna'},
{village:'Ilpanak',province:'Tafea',island:'Tanna'},
{village:'Ilpeutu',province:'Tafea',island:'Tanna'},
{village:'Ilvukalam (Cook\'s Bay)',province:'Tafea',island:'Erromango'},
{village:'Imaelone',province:'Tafea',island:'Tanna'},
{village:'Imaemsine',province:'Tafea',island:'Tanna'},
{village:'Imaen',province:'Tafea',island:'Tanna'},
{village:'Imafen',province:'Tafea',island:'Tanna'},
{village:'Imai',province:'Tafea',island:'Tanna'},
{village:'Imaia',province:'Tafea',island:'Tanna'},
{village:'Imakal',province:'Tafea',island:'Tanna'},
{village:'Imaki',province:'Tafea',island:'Tanna'},
{village:'Imale',province:'Tafea',island:'Aniwa'},
{village:'Imalet',province:'Tafea',island:'Tanna'},
{village:'Larkam',province:'Tafea',island:'Tanna'},
{village:'Imana',province:'Tafea',island:'Tanna'},
{village:'Imanaka',province:'Tafea',island:'Tanna'},
{village:'Imanam',province:'Tafea',island:'Tanna'},
{village:'Imapel',province:'Tafea',island:'Tanna'},
{village:'Imapusaine',province:'Tafea',island:'Tanna'},
{village:'Imarae',province:'Tafea',island:'Futuna'},
{village:'Imareupou',province:'Tafea',island:'Tanna'},
{village:'Imarkakak',province:'Tafea',island:'Tanna'},
{village:'Imaru',province:'Tafea',island:'Tanna'},
{village:'Imasa',province:'Tafea',island:'Aniwa'},
{village:'Imasu',province:'Tafea',island:'Tanna'},
{village:'Imauh',province:'Tafea',island:'Tanna'},
{village:'Imayo',province:'Tafea',island:'Tanna'},
{village:'Imnakaip',province:'Tafea',island:'Tanna'},
{village:'Imojev',province:'Tafea',island:'Aneityum'},
{village:'Imtania',province:'Tafea',island:'Aneityum'},
{village:'Imutu',province:'Shefa',island:'Efate'},
{village:'Inap',province:'Tafea',island:'Aneityum'},
{village:'Independence Park',province:'Shefa',island:'Efate'},
{village:'Ipai',province:'Tafea',island:'Tanna'},
{village:'Ipakruan',province:'Tafea',island:'Tanna'},
{village:'Ipau',province:'Tafea',island:'Futuna'},
{village:'Ipeukel',province:'Tafea',island:'Tanna'},
{village:'Ipilmai',province:'Tafea',island:'Tanna'},
{village:'Ipkagien',province:'Tafea',island:'Tanna'},
{village:'Ipkangien',province:'Tafea',island:'Tanna'},
{village:'Ipneme',province:'Tafea',island:'Tanna'},
{village:'Iquaramanu',province:'Tafea',island:'Tanna'},
{village:'Irakik',province:'Tafea',island:'Tanna'},
{village:'Isaaka (West Tanna)',province:'Tafea',island:'Tanna'},
{village:'Isaaka (Whitesands)',province:'Tafea',island:'Tanna'},
{village:'Isangel',province:'Tafea',island:'Tanna'},
{village:'Isangel (S)',province:'Tafea',island:'Tanna'},
{village:'Isarkei',province:'Tafea',island:'Tanna'},
{village:'Isavai',province:'Tafea',island:'Aniwa'},
{village:'Ishia',province:'Tafea',island:'Futuna'},
{village:'Isiai',province:'Tafea',island:'Tanna'},
{village:'Isini',province:'Tafea',island:'Tanna'},
{village:'Isuva',province:'Tafea',island:'Aneityum'},
{village:'Itakoma',province:'Shefa',island:'Tongoa'},
{village:'Itangutu',province:'Tafea',island:'Aniwa'},
{village:'Itapua',province:'Tafea',island:'Tanna'},
{village:'Itaromara',province:'Tafea',island:'Futuna'},
{village:'Itavai',province:'Tafea',island:'Futuna'},
{village:'Itea',province:'Tafea',island:'Aneityum'},
{village:'Itonga',province:'Tafea',island:'Tanna'},
{village:'Itunga',province:'Tafea',island:'Tanna'},
{village:'Iunier',province:'Tafea',island:'Tanna'},
{village:'Ivanawad',province:'Tafea',island:'Aneityum'},
{village:'Ivanelhat',province:'Tafea',island:'Aneityum'},
{village:'Ivenkula',province:'Tafea',island:'Tanna'},
{village:'Iwahlan',province:'Tafea',island:'Tanna'},
{village:'Iwahu',province:'Tafea',island:'Tanna'},
{village:'Iwarao',province:'Tafea',island:'Tanna'},
{village:'Iwarua',province:'Tafea',island:'Tanna'},
{village:'Iwel',province:'Tafea',island:'Tanna'},
{village:'Jacobe Farm',province:'Shefa',island:'Efate'},
{village:'Jemes',province:'Malampa',island:'Uripiv'},
{village:'Leraoto',province:'Malampa',island:'Malekula'},
{village:'Jericho',province:'Malampa',island:'Malekula'},
{village:'Jerusalem',province:'Malampa',island:'Malekula'},
{village:'Joint Court',province:'Shefa',island:'Efate'},
{village:'Kakola',province:'Shefa',island:'Efate'},
{village:'Kalala',province:'Shefa',island:'Epi'},
{village:'Kalali',province:'Tafea',island:'Tanna'},
{village:'Lewaima',province:'Shefa',island:'Tongariki'},
{village:'Kaonameiken',province:'Tafea',island:'Tanna'},
{village:'Karunanen',province:'Tafea',island:'Tanna'},
{village:'Katinaluluiken',province:'Tafea',island:'Tanna'},
{village:'Kausu',province:'Shefa',island:'Epi'},
{village:'Kaweriki',province:'Shefa',island:'Efate'},
{village:'Kelai',province:'Malampa',island:'Paama'},
{village:'Kings Cross',province:'Tafea',island:'Tanna'},
{village:'Kitow',province:'Tafea',island:'Tanna'},
{village:'Kleitaleiken',province:'Tafea',island:'Tanna'},
{village:'Kokonak',province:'Shefa',island:'Tongariki'},
{village:'Kokoreko',province:'Shefa',island:'Efate'},
{village:'Komerana',province:'Shefa',island:'Epi'},
{village:'Kona Point',province:'Malampa',island:'Malekula'},
{village:'Konkon',province:'Malampa',island:'Ambrym'},
{village:'Korman Stadium',province:'Shefa',island:'Efate'},
{village:'Koyarwelekiken',province:'Tafea',island:'Tanna'},
{village:'Kraitanaigen',province:'Tafea',island:'Tanna'},
{village:'Kurumambe',province:'Shefa',island:'Tongoa'},
{village:'Kurumbat',province:'Shefa',island:'Buninga'},
{village:'Kwamera',province:'Tafea',island:'Tanna'},
{village:'Yakwaraka',province:'Tafea',island:'Tanna'},
{village:'Kwataparen',province:'Tafea',island:'Tanna'},
{village:'La Bay',province:'Shefa',island:'Efate'},
{village:'La Cressonniere',province:'Shefa',island:'Efate'},
{village:'La Mine',province:'Shefa',island:'Efate'},
{village:'Labetbak',province:'Malampa',island:'Malekula'},
{village:'Labo',province:'Malampa',island:'Malekula'},
{village:'Labulwol',province:'Malampa',island:'Malekula'},
{village:'Labung',province:'Malampa',island:'Malekula'},
{village:'Laburbahur',province:'Malampa',island:'Akhamb'},
{village:'Labursur',province:'Malampa',island:'Malekula'},
{village:'Lafna',province:'Tafea',island:'Tanna'},
{village:'Lahwenata',province:'Tafea',island:'Tanna'},
{village:'Lahwenuwi',province:'Tafea',island:'Tanna'},
{village:'Laimira',province:'Tafea',island:'Tanna'},
{village:'Lairyem',province:'Malampa',island:'Malekula'},
{village:'Lakalangia',province:'Tafea',island:'Tanna'},
{village:'Lalua',province:'Shefa',island:'Efate'},
{village:'Lakatoro',province:'Malampa',island:'Malekula'},
{village:'Saama',province:'Shefa',island:'Efate'},
{village:'Laketam',province:'Tafea',island:'Tanna'},
{village:'Lakilia',province:'Shefa',island:'Tongariki'},
{village:'Laklopulor',province:'Shefa',island:'Efate'},
{village:'Lalep',province:'Malampa',island:'Malekula'},
{village:'Lalinda',province:'Malampa',island:'Ambrym'},
{village:'Lalinda S.D.A',province:'Malampa',island:'Ambrym'},
{village:'Lalkofe',province:'Malampa',island:'Malekula'},
{village:'Lama Mountian (Snake Hill)',province:'Shefa',island:'Efate'},
{village:'Lamahnuat',province:'Tafea',island:'Tanna'},
{village:'Lamakawin',province:'Tafea',island:'Tanna'},
{village:'Lamal',province:'Tafea',island:'Tanna'},
{village:'Lamalalmita',province:'Tafea',island:'Tanna'},
{village:'Lamaling',province:'Tafea',island:'Tanna'},
{village:'Lamanafa',province:'Tafea',island:'Tanna'},
{village:'Lamanamilang',province:'Tafea',island:'Tanna'},
{village:'Lamanapiep',province:'Tafea',island:'Tanna'},
{village:'Lamanapiepi',province:'Tafea',island:'Tanna'},
{village:'Lamanaruan',province:'Tafea',island:'Tanna'},
{village:'Lamangoati',province:'Tafea',island:'Tanna'},
{village:'Lamanian',province:'Tafea',island:'Tanna'},
{village:'Lamaniu Tuan',province:'Tafea',island:'Tanna'},
{village:'Lamanul',province:'Tafea',island:'Tanna'},
{village:'Lamanuo',province:'Tafea',island:'Tanna'},
{village:'Lambeniar',province:'Malampa',island:'Akhamb'},
{village:'Lambonburi',province:'Malampa',island:'Malekula'},
{village:'Lambre',province:'Malampa',island:'Malekula'},
{village:'Lambulmbatuei',province:'Malampa',island:'Malekula'},
{village:'Lamburnaus',province:'Malampa',island:'Akhamb'},
{village:'Lamenu Bay',province:'Shefa',island:'Epi'},
{village:'Laminaora',province:'Tafea',island:'Tanna'},
{village:'Laminuha',province:'Tafea',island:'Tanna'},
{village:'Lamitatal',province:'Tafea',island:'Tanna'},
{village:'Lamkail',province:'Tafea',island:'Tanna'},
{village:'Lamlo',province:'Malampa',island:'Malekula'},
{village:'Lamlu',province:'Tafea',island:'Tanna'},
{village:'Lamnatu',province:'Tafea',island:'Tanna'},
{village:'Lampu',province:'Malampa',island:'Lembong'},
{village:'Lamrao',province:'Tafea',island:'Tanna'},
{village:'Lamthawekal',province:'Tafea',island:'Tanna'},
{village:'Lenaulawul',province:'Tafea',island:'Tanna'},
{village:'Lanfitfit',province:'Malampa',island:'Malekula'},
{village:'Lanigebog',province:'Malampa',island:'Malekula'},
{village:'Lanimlelang',province:'Tafea',island:'Tanna'},
{village:'Laninik',province:'Tafea',island:'Tanna'},
{village:'Lanver',province:'Malampa',island:'Ambrym'},
{village:'Laol',province:'Tafea',island:'Tanna'},
{village:'Lounap Kayoayo',province:'Tafea',island:'Tanna'},
{village:'Lapang Nuo',province:'Tafea',island:'Tanna'},
{village:'Lapang Nuying',province:'Tafea',island:'Tanna'},
{village:'Lapang Tuai',province:'Tafea',island:'Tanna'},
{village:'Lapangtowa',province:'Tafea',island:'Tanna'},
{village:'Lapasalis',province:'Tafea',island:'Tanna'},
{village:'Lapkit',province:'Tafea',island:'Tanna'},
{village:'Lapnuman',province:'Tafea',island:'Tanna'},
{village:'Larevet',province:'Malampa',island:'Malekula'},
{village:'Laruanu',province:'Tafea',island:'Tanna'},
{village:'Larur',province:'Malampa',island:'Malekula'},
{village:'Lasarav',province:'Malampa',island:'Malekula'},
{village:'Lasofsa',province:'Malampa',island:'Malekula'},
{village:'Lastsopsah',province:'Malampa',island:'Malekula'},
{village:'Latapu',province:'Tafea',island:'Tanna'},
{village:'Latuei',province:'Tafea',island:'Tanna'},
{village:'Latun',province:'Tafea',island:'Tanna'},
{village:'Laukau',province:'Tafea',island:'Tanna'},
{village:'Launamoa',province:'Shefa',island:'Pele'},
{village:'Lounapkamim',province:'Tafea',island:'Tanna'},
{village:'Laur',province:'Tafea',island:'Tanna'},
{village:'Laus',province:'Tafea',island:'Tanna'},
{village:'Lausake',province:'Shefa',island:'Emau'},
{village:'Lautapunga',province:'Tafea',island:'Tanna'},
{village:'Lavalsal',province:'Malampa',island:'Malekula'},
{village:'Lavame',province:'Malampa',island:'Vao'},
{village:'Lavor',province:'Malampa',island:'Malekula'},
{village:'Lawa',province:'Malampa',island:'Malekula'},
{village:'Lawangi',province:'Tafea',island:'Tanna'},
{village:'Lawenata',province:'Tafea',island:'Tanna'},
{village:'Lawesinwe',province:'Malampa',island:'Malekula'},
{village:'Lawir',province:'Tafea',island:'Tanna'},
{village:'Lawital',province:'Tafea',island:'Tanna'},
{village:'Le Lagoon',province:'Shefa',island:'Efate'},
{village:'Lehili',province:'Malampa',island:'Paama'},
{village:'Lei',province:'Malampa',island:'Malekula'},
{village:'Lekan',province:'Malampa',island:'Malekula'},
{village:'Lekapo',province:'Tafea',island:'Tanna'},
{village:'Leken',province:'Malampa',island:'Malekula'},
{village:'Leketam',province:'Tafea',island:'Tanna'},
{village:'Lele',province:'Malampa',island:'Ambrym'},
{village:'Lelepa Landing',province:'Shefa',island:'Efate'},
{village:'Lelo',province:'Shefa',island:'Lelepa'},
{village:'Lelualu',province:'Tafea',island:'Tanna'},
{village:'Lemboro',province:'Shefa',island:'Epi'},
{village:'Lemaru',province:'Shefa',island:'Epi'},
{village:'Lohornias',province:'Malampa',island:'Malekula'},
{village:'Lembetiar',province:'Malampa',island:'Malekula'},
{village:'Lembongbong',province:'Malampa',island:'Malekula'},
{village:'Lembu',province:'Malampa',island:'Lembong'},
{village:'Lempeto',province:'Shefa',island:'Epi'},
{village:'Lemsess',province:'Malampa',island:'Akhamb'},
{village:'Lenafa',province:'Tafea',island:'Tanna'},
{village:'Lenakel',province:'Tafea',island:'Tanna'},
{village:'Lenaken',province:'Tafea',island:'Tanna'},
{village:'Lenamir',province:'Tafea',island:'Tanna'},
{village:'Lenarawia',province:'Tafea',island:'Tanna'},
{village:'Lenatam',province:'Tafea',island:'Tanna'},
{village:'Lenawawa',province:'Tafea',island:'Tanna'},
{village:'Lendo',province:'Malampa',island:'Malekula'},
{village:'Leneai',province:'Tafea',island:'Tanna'},
{village:'Lenemita',province:'Tafea',island:'Tanna'},
{village:'Lenepin',province:'Tafea',island:'Tanna'},
{village:'Lenepir',province:'Tafea',island:'Tanna'},
{village:'Lenmawut',province:'Tafea',island:'Tanna'},
{village:'Lenoakas',province:'Tafea',island:'Tanna'},
{village:'Lenpeukel',province:'Tafea',island:'Tanna'},
{village:'Lenpupu Nipin',province:'Tafea',island:'Tanna'},
{village:'Lenuvalu',province:'Tafea',island:'Tanna'},
{village:'Mount Zion',province:'Shefa',island:'Tongoa'},
{village:'Lepa',province:'Shefa',island:'Epi'},
{village:'Lepinmas',province:'Malampa',island:'Malekula'},
{village:'Topet',province:'Malampa',island:'Malekula'},
{village:'Lepuku',province:'Tafea',island:'Tanna'},
{village:'Lerongrong',province:'Malampa',island:'Malekula'},
{village:'Lesarasom',province:'Malampa',island:'Malekula'},
{village:'Lesarnalas',province:'Malampa',island:'Malekula'},
{village:'Lesbeh',province:'Malampa',island:'Malekula'},
{village:'Lesekere',province:'Malampa',island:'Malekula'},
{village:'Lesinan',province:'Tafea',island:'Tanna'},
{village:'Lesusu',province:'Shefa',island:'Epi'},
{village:'Letawaus',province:'Tafea',island:'Tanna'},
{village:'Letephuei',province:'Malampa',island:'Malekula'},
{village:'Letevtev',province:'Malampa',island:'Malekula'},
{village:'Letokas',province:'Malampa',island:'Malekula'},
{village:'Letowopam',province:'Tafea',island:'Tanna'},
{village:'Levetbao',province:'Malampa',island:'Malekula'},
{village:'Leviam 1',province:'Malampa',island:'Malekula'},
{village:'Leviam 2',province:'Malampa',island:'Malekula'},
{village:'Levis',province:'Malampa',island:'Malekula'},
{village:'Levlik',province:'Tafea',island:'Tanna'},
{village:'Lewiar',province:'Tafea',island:'Tanna'},
{village:'Lowinebuas',province:'Malampa',island:'Malekula'},
{village:'Lijonkjonk',province:'Malampa',island:'Akhamb'},
{village:'Limap',province:'Malampa',island:'Malekula'},
{village:'Linbul',province:'Malampa',island:'Ambrym'},
{village:'Lindrong',province:'Malampa',island:'Malekula'},
{village:'Lingarakh',province:'Malampa',island:'Malekula'},
{village:'Liro',province:'Malampa',island:'Paama'},
{village:'Liro Nessa',province:'Malampa',island:'Paama'},
{village:'Lisava',province:'Shefa',island:'Epi'},
{village:'Litslits',province:'Malampa',island:'Malekula'},
{village:'Livet',province:'Malampa',island:'Malekula'},
{village:'Loaneai',province:'Tafea',island:'Tanna'},
{village:'Loanengo',province:'Tafea',island:'Tanna'},
{village:'Loearfi',province:'Tafea',island:'Tanna'},
{village:'Lorlow',province:'Malampa',island:'Malekula'},
{village:'Lorhorvar',province:'Malampa',island:'Malekula'},
{village:'Lokaim',province:'Tafea',island:'Tanna'},
{village:'Loknarap',province:'Tafea',island:'Tanna'},
{village:'Lokopuwi',province:'Shefa',island:'Epi'},
{village:'Lolibulo',province:'Malampa',island:'Ambrym'},
{village:'Lolira',province:'Malampa',island:'Ambrym'},
{village:'Tobol',province:'Malampa',island:'Ambrym'},
{village:'Lololima',province:'Shefa',island:'Efate'},
{village:'Lolomal',province:'Malampa',island:'Malekula'},
{village:'Lolonwei',province:'Malampa',island:'Ambrym'},
{village:'Lomalkai',province:'Malampa',island:'Malekula'},
{village:'Lonawa',province:'Malampa',island:'Ambrym'},
{village:'Lonbasil',province:'Malampa',island:'Ambrym'},
{village:'Wuro',province:'Malampa',island:'Ambrym'},
{village:'Lonbwe (Ambrym)',province:'Malampa',island:'Ambrym'},
{village:'Lonre',province:'Malampa',island:'Ambrym'},
{village:'Lonkar',province:'Malampa',island:'Malekula'},
{village:'Lonmek',province:'Malampa',island:'Ambrym'},
{village:'Lonmei',province:'Malampa',island:'Ambrym'},
{village:'Lonororo',province:'Malampa',island:'Ambrym'},
{village:'Lonyeokon',province:'Malampa',island:'Ambrym'},
{village:'Lopalis',province:'Shefa',island:'Epi'},
{village:'Lopika',province:'Shefa',island:'Epi'},
{village:'Tsinowone',province:'Malampa',island:'Malekula'},
{village:'Lopri',province:'Malampa',island:'Atchin'},
{village:'Lorelivo',province:'Malampa',island:'Malekula'},
{village:'Lorore',province:'Malampa',island:'Malekula'},
{village:'Louakal',province:'Tafea',island:'Tanna'},
{village:'Louamel',province:'Tafea',island:'Tanna'},
{village:'Louanatom',province:'Tafea',island:'Tanna'},
{village:'Louanatuan',province:'Tafea',island:'Tanna'},
{village:'Louaneai',province:'Tafea',island:'Tanna'},
{village:'Louaneiai',province:'Tafea',island:'Tanna'},
{village:'Loubali',province:'Tafea',island:'Tanna'},
{village:'Louealeuv',province:'Tafea',island:'Tanna'},
{village:'Loueao',province:'Tafea',island:'Tanna'},
{village:'Louelapoma',province:'Tafea',island:'Tanna'},
{village:'Louiaru',province:'Tafea',island:'Tanna'},
{village:'Louikao',province:'Tafea',island:'Tanna'},
{village:'Louital',province:'Tafea',island:'Tanna'},
{village:'Loukahwain',province:'Tafea',island:'Tanna'},
{village:'Loukalou',province:'Tafea',island:'Tanna'},
{village:'Loukanawuk',province:'Tafea',island:'Tanna'},
{village:'Loukaolis',province:'Tafea',island:'Tanna'},
{village:'Loukatai',province:'Tafea',island:'Tanna'},
{village:'Loukulua',province:'Tafea',island:'Tanna'},
{village:'Loukweria',province:'Tafea',island:'Tanna'},
{village:'Louliuliu',province:'Tafea',island:'Tanna'},
{village:'Loumetuan',province:'Tafea',island:'Tanna'},
{village:'Loumia',province:'Tafea',island:'Tanna'},
{village:'Lounahuan',province:'Tafea',island:'Tanna'},
{village:'Lounakik',province:'Tafea',island:'Tanna'},
{village:'Lounakke',province:'Tafea',island:'Tanna'},
{village:'Lounakura',province:'Tafea',island:'Tanna'},
{village:'Lounamal',province:'Tafea',island:'Tanna'},
{village:'Lounamilo',province:'Tafea',island:'Tanna'},
{village:'Lounang',province:'Tafea',island:'Tanna'},
{village:'Lounapaiu',province:'Tafea',island:'Tanna'},
{village:'Lounapalulua',province:'Tafea',island:'Tanna'},
{village:'Lounapikmita',province:'Tafea',island:'Tanna'},
{village:'Lounapikruan',province:'Tafea',island:'Tanna'},
{village:'Lounapil',province:'Tafea',island:'Tanna'},
{village:'Lounapkamei',province:'Tafea',island:'Tanna'},
{village:'Lounapkao',province:'Tafea',island:'Tanna'},
{village:'Lownapkarap',province:'Tafea',island:'Tanna'},
{village:'Lounapkau Langis',province:'Tafea',island:'Tanna'},
{village:'Lounapkousim',province:'Tafea',island:'Tanna'},
{village:'Lounapuak',province:'Tafea',island:'Tanna'},
{village:'Lounapuas',province:'Tafea',island:'Tanna'},
{village:'Lounara',province:'Tafea',island:'Tanna'},
{village:'Lounatanu',province:'Tafea',island:'Tanna'},
{village:'Lounatim',province:'Tafea',island:'Tanna'},
{village:'Lounelapen',province:'Tafea',island:'Tanna'},
{village:'Louni',province:'Malampa',island:'Malekula'},
{village:'Louniel',province:'Tafea',island:'Tanna'},
{village:'Lounihm',province:'Tafea',island:'Tanna'},
{village:'Lounikawik',province:'Tafea',island:'Tanna'},
{village:'Lounim Ahapen',province:'Tafea',island:'Tanna'},
{village:'Louniparu',province:'Tafea',island:'Tanna'},
{village:'Lounoah',province:'Tafea',island:'Tanna'},
{village:'Lounou',province:'Tafea',island:'Tanna'},
{village:'Lousiganu',province:'Tafea',island:'Tanna'},
{village:'Lousivir',province:'Tafea',island:'Tanna'},
{village:'Louteth',province:'Tafea',island:'Tanna'},
{village:'Witava',province:'Malampa',island:'Malekula'},
{village:'Lowakao',province:'Tafea',island:'Tanna'},
{village:'Lowanpakel',province:'Tafea',island:'Tanna'},
{village:'Loweao',province:'Tafea',island:'Tanna'},
{village:'Melkon',province:'Malampa',island:'Ambrym'},
{village:'Lowkamas',province:'Tafea',island:'Tanna'},
{village:'Lowkanel',province:'Tafea',island:'Tanna'},
{village:'Lowkaru',province:'Tafea',island:'Tanna'},
{village:'Lowkas',province:'Tafea',island:'Tanna'},
{village:'Lowkaulas',province:'Tafea',island:'Tanna'},
{village:'Lowkweria (Sw Tanna)',province:'Tafea',island:'Tanna'},
{village:'Lowmatumatu',province:'Tafea',island:'Tanna'},
{village:'Lownaleng',province:'Tafea',island:'Tanna'},
{village:'Lownang',province:'Tafea',island:'Tanna'},
{village:'Lownaowla',province:'Tafea',island:'Tanna'},
{village:'Lownapik Tenaomus',province:'Tafea',island:'Tanna'},
{village:'Lownapiktuan',province:'Tafea',island:'Tanna'},
{village:'Lownapkamei',province:'Tafea',island:'Tanna'},
{village:'Lownapkiko',province:'Tafea',island:'Tanna'},
{village:'Lownasunan',province:'Tafea',island:'Tanna'},
{village:'Lownekawek',province:'Tafea',island:'Tanna'},
{village:'Lownepina',province:'Tafea',island:'Tanna'},
{village:'Lownik',province:'Tafea',island:'Tanna'},
{village:'Lowoetuma',province:'Tafea',island:'Tanna'},
{village:'Lowpukas',province:'Tafea',island:'Tanna'},
{village:'Lowtaliko',province:'Tafea',island:'Tanna'},
{village:'Lowteklepe-Tuan',province:'Tafea',island:'Tanna'},
{village:'Lowya',province:'Tafea',island:'Tanna'},
{village:'Luhe',province:'Malampa',island:'Ambrym'},
{village:'Lulep',province:'Malampa',island:'Paama'},
{village:'Luli',province:'Malampa',island:'Paama'},
{village:'Lumbukuti',province:'Shefa',island:'Tongoa'},
{village:'Lupalea',province:'Shefa',island:'Tongoa'},
{village:'Lutes',province:'Malampa',island:'Uliveo'},
{village:'Lu\'Umow',province:'Malampa',island:'Malekula'},
{village:'Maat',province:'Malampa',island:'Ambrym'},
{village:'Mabfilau',province:'Shefa',island:'Epi'},
{village:'Mae',province:'Malampa',island:'Malekula'},
{village:'Magam',province:'Malampa',island:'Ambrym'},
{village:'Mahafo',province:'Malampa',island:'Malekula'},
{village:'Makatu',province:'Shefa',island:'Emae'},
{village:'Makatu Natiti',province:'Shefa',island:'Emae'},
{village:'Malafao',province:'Shefa',island:'Efate'},
{village:'Malafau',province:'Shefa',island:'Epi'},
{village:'Malakoto',province:'Shefa',island:'Makira'},
{village:'Malaliu',province:'Shefa',island:'Nguna'},
{village:'Malapoa Whitewood',province:'Shefa',island:'Efate'},
{village:'Nekapa',province:'Shefa',island:'Nguna'},
{village:'Malaripu (Melemaat)',province:'Shefa',island:'Efate'},
{village:'Malenra',province:'Malampa',island:'Akhamb'},
{village:'Maliabor',province:'Malampa',island:'Akhamb'},
{village:'Mesire',province:'Shefa',island:'Ifira'},
{village:'Malpasi',province:'Shefa',island:'Epi'},
{village:'Malua Bay',province:'Malampa',island:'Malekula'},
{village:'Malvakal',province:'Malampa',island:'Malekula'},
{village:'Malvet',province:'Malampa',island:'Ambrym'},
{village:'Manaro',province:'Sanma',island:'Santo'},
{village:'Manbae',province:'Shefa',island:'Epi'},
{village:'Mangaliliu',province:'Shefa',island:'Efate'},
{village:'Manganua',province:'Shefa',island:'Epi'},
{village:'Mangarisu',province:'Shefa',island:'Tongoa'},
{village:'Mangarongo',province:'Shefa',island:'Emau'},
{village:'Mangas',province:'Shefa',island:'Efate'},
{village:'Mangogo',province:'Shefa',island:'Epi'},
{village:'Manicon',province:'Shefa',island:'Epi'},
{village:'Manioc',province:'Shefa',island:'Epi'},
{village:'Manples',province:'Shefa',island:'Efate'},
{village:'Mansaomalo',province:'Shefa',island:'Efate'},
{village:'Manuapen',province:'Tafea',island:'Tanna'},
{village:'Manul',province:'Shefa',island:'Epi'},
{village:'Mobarawa',province:'Shefa',island:'Epi'},
{village:'Mapua',province:'Shefa',island:'Emau'},
{village:'Mapuna',province:'Shefa',island:'Epi'},
{village:'Mapvilao',province:'Shefa',island:'Epi'},
{village:'Marae',province:'Shefa',island:'Emae'},
{village:'Maranata',province:'Malampa',island:'Ambrym'},
{village:'Marbaho',province:'Malampa',island:'Malekula'},
{village:'Mariraw',province:'Malampa',island:'Akhamb'},
{village:'Maritao',province:'Shefa',island:'Efate'},
{village:'Marow',province:'Shefa',island:'Emau'},
{village:'Marpagho',province:'Malampa',island:'Malekula'},
{village:'Marybel',province:'Malampa',island:'Malekula'},
{village:'Masap',province:'Malampa',island:'Ambrym'},
{village:'Masimia',province:'Shefa',island:'Epi'},
{village:'Masou',province:'Shefa',island:'Epi'},
{village:'Matangi (Tongoa)',province:'Shefa',island:'Tongoa'},
{village:'Matannamal ( Teuma Bush)',province:'Shefa',island:'Efate'},
{village:'Matanvath',province:'Malampa',island:'Malekula'},
{village:'Matarisu',province:'Shefa',island:'Efate'},
{village:'Mate 1',province:'Shefa',island:'Epi'},
{village:'Mate 2',province:'Shefa',island:'Epi'},
{village:'Matesu',province:'Shefa',island:'Epi'},
{village:'Matevulu Farm',province:'Sanma',island:'Santo'},
{village:'Matevulu Village',province:'Sanma',island:'Santo'},
{village:'Matoa',province:'Shefa',island:'Nguna'},
{village:'Maturu',province:'Shefa',island:'Lelepa'},
{village:'Maumau (Teouma Bush Eton)',province:'Shefa',island:'Efate'},
{village:'Renau',province:'Malampa',island:'Ambrym'},
{village:'Mbangir',province:'Malampa',island:'Malekula'},
{village:'Mbareas',province:'Malampa',island:'Ambrym'},
{village:'Mbatambu',province:'Malampa',island:'Malekula'},
{village:'Mbembe',province:'Shefa',island:'Epi'},
{village:'Mbenenavet',province:'Malampa',island:'Malekula'},
{village:'Mboi',province:'Malampa',island:'Ambrym'},
{village:'Serembo',province:'Sanma',island:'Santo'},
{village:'Mbwarih',province:'Shefa',island:'Buninga'},
{village:'Mbwatbang',province:'Malampa',island:'Malekula'},
{village:'Mbwitin',province:'Malampa',island:'Malekula'},
{village:'Mehup',province:'Malampa',island:'Ambrym'},
{village:'Melbwera',province:'Malampa',island:'Ambrym'},
{village:'Mele',province:'Shefa',island:'Efate'},
{village:'Meleb',province:'Malampa',island:'Malekula'},
{village:'Melerere',province:'Malampa',island:'Rano'},
{village:'Pinawae',province:'Malampa',island:'Malekula'},
{village:'Meleven Mango',province:'Malampa',island:'Malekula'},
{village:'Melip',province:'Malampa',island:'Malekula'},
{village:'Melken',province:'Malampa',island:'Malekula'},
{village:'Melmarur',province:'Malampa',island:'Atchin'},
{village:'Melnamol',province:'Malampa',island:'Rano'},
{village:'Melnatoro',province:'Malampa',island:'Wala'},
{village:'Melowoie',province:'Malampa',island:'Malekula'},
{village:'Melpulpul',province:'Malampa',island:'Ambrym'},
{village:'Melten',province:'Malampa',island:'Ambrym'},
{village:'Meltou',province:'Malampa',island:'Ambrym'},
{village:'Meltugon',province:'Malampa',island:'Ambrym'},
{village:'Melvar',province:'Malampa',island:'Ambrym'},
{village:'Mengamone',province:'Malampa',island:'Ambrym'},
{village:'Mere',province:'Shefa',island:'Nguna'},
{village:'Merenraf',province:'Sanma',island:'Santo'},
{village:'Meriser',province:'Malampa',island:'Akhamb'},
{village:'Meriu',province:'Shefa',island:'Tongoa'},
{village:'Merivar',province:'Malampa',island:'Malekula'},
{village:'Merosi',province:'Shefa',island:'Epi'},
{village:'Metano',province:'Shefa',island:'Epi'},
{village:'Sameou',province:'Malampa',island:'Ambrym'},
{village:'Meten',province:'Shefa',island:'Efate'},
{village:'Metitar',province:'Malampa',island:'Malekula'},
{village:'Metkhun',province:'Malampa',island:'Malekula'},
{village:'Missen',province:'Shefa',island:'Epi'},
{village:'Molin',province:'Malampa',island:'Malekula'},
{village:'Montmatre',province:'Shefa',island:'Efate'},
{village:'Moriu',province:'Shefa',island:'Epi'},
{village:'Moru',province:'Malampa',island:'Ambrym'},
{village:'Morua',province:'Shefa',island:'Tongoa'},
{village:'Mrere',province:'Malampa',island:'Malekula'},
{village:'Muura',province:'Shefa',island:'Tongariki'},
{village:'Na\'Asang',province:'Shefa',island:'Mataso'},
{village:'Napangvie',province:'Shefa',island:'Efate'},
{village:'Nakiroa',province:'Tafea',island:'Futuna'},
{village:'Nalema',province:'Shefa',island:'Epi'},
{village:'Unalvin',province:'Tafea',island:'Erromango'},
{village:'Nambagura',province:'Malampa',island:'Malekula'},
{village:'Nambangasale',province:'Shefa',island:'Tongoa'},
{village:'Nambar',province:'Malampa',island:'Malekula'},
{village:'Nambatri (Efate)',province:'Shefa',island:'Efate'},
{village:'Nambatri (Epi)',province:'Shefa',island:'Epi'},
{village:'Nambatri Ellouk',province:'Shefa',island:'Efate'},
{village:'Nambatu',province:'Shefa',island:'Efate'},
{village:'Nambatu Wallis',province:'Shefa',island:'Efate'},
{village:'Namburakai',province:'Malampa',island:'Malekula'},
{village:'Namburu',province:'Shefa',island:'Efate'},
{village:'Nampecko',province:'Sanma',island:'Santo'},
{village:'Naos',province:'Malampa',island:'Malekula'},
{village:'Napkoa',province:'Shefa',island:'Efate'},
{village:'Napua',province:'Tafea',island:'Futuna'},
{village:'Naraniem',province:'Malampa',island:'Malekula'},
{village:'Narhayes',province:'Malampa',island:'Malekula'},
{village:'Narlam',province:'Malampa',island:'Malekula'},
{village:'Ponumbia',province:'Tafea',island:'Erromango'},
{village:'Naser',province:'Malampa',island:'Malekula'},
{village:'Naship',province:'Tafea',island:'Erromango'},
{village:'Natapau',province:'Shefa',island:'Lelepa'},
{village:'Wortatsa',province:'Malampa',island:'Malekula'},
{village:'Nawating',province:'Tafea',island:'Tanna'},
{village:'Nba',province:'Malampa',island:'Malekula'},
{village:'Nduen',province:'Malampa',island:'Malekula'},
{village:'Ranvergere',province:'Malampa',island:'Ambrym'},
{village:'Nehatling',province:'Malampa',island:'Ambrym'},
{village:'Neramb',province:'Malampa',island:'Malekula'},
{village:'Ngalokumal',province:'Shefa',island:'Lamen'},
{village:'Ngaloparua',province:'Shefa',island:'Lamen'},
{village:'Ngalovasoro',province:'Shefa',island:'Lamen'},
{village:'Ngao',province:'Shefa',island:'Epi'},
{village:'Ngaone',province:'Shefa',island:'Emae'},
{village:'Ngevin',province:'Shefa',island:'Epi'},
{village:'Ngurua',province:'Shefa',island:'Emau'},
{village:'Nijorana',province:'Tafea',island:'Aneityum'},
{village:'Nikaura',province:'Shefa',island:'Epi'},
{village:'Niku',province:'Shefa',island:'Epi'},
{village:'Niu Ples',province:'Shefa',island:'Epi'},
{village:'Nivenue',province:'Shefa',island:'Epi'},
{village:'Nmew',province:'Malampa',island:'Malekula'},
{village:'Nokosake',province:'Shefa',island:'Ifira'},
{village:'Unognombi',province:'Tafea',island:'Erromango'},
{village:'Norowre',province:'Malampa',island:'Vao'},
{village:'Norsup',province:'Malampa',island:'Norsup'},
{village:'Nou',province:'Malampa',island:'Paama'},
{village:'Nouha',province:'Malampa',island:'Ambrym'},
{village:'Novor',province:'Malampa',island:'Malekula'},
{village:'Nramiong',province:'Malampa',island:'Akhamb'},
{village:'Nubukakar',province:'Malampa',island:'Malekula'},
{village:'Nukon',province:'Malampa',island:'Ambrym'},
{village:'Nul Nessa',province:'Shefa',island:'Epi'},
{village:'Nupuesjec',province:'Tafea',island:'Aneityum'},
{village:'Nuvi',province:'Shefa',island:'Epi'},
{village:'Oailep',province:'Malampa',island:'Paama'},
{village:'Ohlen',province:'Shefa',island:'Efate'},
{village:'Ohlen Freswin',province:'Shefa',island:'Efate'},
{village:'Ohlen Mataso',province:'Shefa',island:'Efate'},
{village:'Ohlen Nambanga',province:'Shefa',island:'Efate'},
{village:'Ohyabo',province:'Malampa',island:'Malekula'},
{village:'Olal',province:'Malampa',island:'Ambrym'},
{village:'Olam',province:'Malampa',island:'Malekula'},
{village:'Omale',province:'Malampa',island:'Malekula'},
{village:'Onesua',province:'Shefa',island:'Efate'},
{village:'Orap',province:'Malampa',island:'Malekula'},
{village:'Oreau',province:'Shefa',island:'Epi'},
{village:'Oroni',province:'Malampa',island:'Malekula'},
{village:'P Late',province:'Shefa',island:'Epi'},
{village:'Paen',province:'Shefa',island:'Epi'},
{village:'Paia',province:'Shefa',island:'Epi'},
{village:'Paita',province:'Malampa',island:'Malekula'},
{village:'Palu',province:'Malampa',island:'Malekula'},
{village:'Pamal',province:'Malampa',island:'Ambrym'},
{village:'Pandeur',province:'Malampa',island:'Malekula'},
{village:'Pang Pang',province:'Shefa',island:'Efate'},
{village:'Pangona',province:'Shefa',island:'Efate'},
{village:'Pango',province:'Shefa',island:'Efate'},
{village:'Pango Esnar',province:'Shefa',island:'Efate'},
{village:'Panita',province:'Shefa',island:'Tongoa'},
{village:'Pao',province:'Malampa',island:'Malekula'},
{village:'Paonangisu',province:'Shefa',island:'Efate'},
{village:'Paradise',province:'Malampa',island:'Malekula'},
{village:'Parereu',province:'Malampa',island:'Ambrym'},
{village:'Pele',province:'Shefa',island:'Tongoa'},
{village:'Pelipetakever',province:'Malampa',island:'Ambrym'},
{village:'Pellonk',province:'Malampa',island:'Uliveo'},
{village:'Penamur',province:'Malampa',island:'Malekula'},
{village:'Penap',province:'Malampa',island:'Malekula'},
{village:'Penapo',province:'Malampa',island:'Ambrym'},
{village:'Penesies',province:'Malampa',island:'Malekula'},
{village:'Pepeksat',province:'Malampa',island:'Malekula'},
{village:'Perusa',province:'Tafea',island:'Erromango'},
{village:'Peskarus',province:'Malampa',island:'Uliveo'},
{village:'Petengar',province:'Malampa',island:'Malekula'},
{village:'Petere',province:'Malampa',island:'Malekula'},
{village:'Peterpu',province:'Malampa',island:'Malekula'},
{village:'Petervat',province:'Malampa',island:'Malekula'},
{village:'Pibonbonne',province:'Malampa',island:'Malekula'},
{village:'Pikaer',province:'Malampa',island:'Malekula'},
{village:'Piliura',province:'Shefa',island:'Pele'},
{village:'Pimeh',province:'Malampa',island:'Malekula'},
{village:'Pinalum',province:'Malampa',island:'Malekula'},
{village:'Pinbang',province:'Malampa',island:'Ambrym'},
{village:'Poi',province:'Shefa',island:'Efate'},
{village:'Pongkil',province:'Tafea',island:'Erromango'},
{village:'Pongovia',province:'Shefa',island:'Epi'},
{village:'Pontirausak',province:'Tafea',island:'Erromango'},
{village:'Pontutu',province:'Tafea',island:'Erromango'},
{village:'Ponusia',province:'Tafea',island:'Erromango'},
{village:'Porantop',province:'Tafea',island:'Erromango'},
{village:'Port Havanah',province:'Shefa',island:'Efate'},
{village:'Votlo',province:'Shefa',island:'Epi'},
{village:'Sara (Epi)',province:'Shefa',island:'Epi'},
{village:'Port Narvin',province:'Tafea',island:'Erromango'},
{village:'Port Sandwich',province:'Malampa',island:'Malekula'},
{village:'Portnere',province:'Tafea',island:'Erromango'},
{village:'Potapsipsip',province:'Tafea',island:'Erromango'},
{village:'Potco',province:'Malampa',island:'Malekula'},
{village:'Potindir',province:'Malampa',island:'Malekula'},
{village:'Potlusi',province:'Tafea',island:'Erromango'},
{village:'Potnambe',province:'Malampa',island:'Uripiv'},
{village:'Poton',province:'Malampa',island:'Wala'},
{village:'Potora',province:'Malampa',island:'Rano'},
{village:'Potun',province:'Malampa',island:'Uripiv'},
{village:'Potwai',province:'Tafea',island:'Erromango'},
{village:'Preng',province:'Malampa',island:'Wala'},
{village:'Prima',province:'Shefa',island:'Efate'},
{village:'Pukura',province:'Shefa',island:'Efate'},
{village:'Pulkawa',province:'Shefa',island:'Epi'},
{village:'Pumari',province:'Tafea',island:'Erromango'},
{village:'Rampunetvol',province:'Tafea',island:'Erromango'},
{village:'Punnompuat',province:'Tafea',island:'Erromango'},
{village:'Pur',province:'Malampa',island:'Malekula'},
{village:'Purao',province:'Shefa',island:'Tongoa'},
{village:'Pute',province:'Shefa',island:'Epi'},
{village:'Rabetewau',province:'Malampa',island:'Ambrym'},
{village:'Ramaso',province:'Malampa',island:'Atchin'},
{village:'Rambek',province:'Malampa',island:'Malekula'},
{village:'Rambuan',province:'Malampa',island:'Malekula'},
{village:'Rampunmougo',province:'Tafea',island:'Erromango'},
{village:'Rampunrungu',province:'Tafea',island:'Erromango'},
{village:'Rampunwemog',province:'Tafea',island:'Erromango'},
{village:'Rana',province:'Shefa',island:'Epi'},
{village:'Ranbe',province:'Malampa',island:'Ambrym'},
{village:'Ranbetewau',province:'Malampa',island:'Ambrym'},
{village:'Ranhor',province:'Malampa',island:'Ambrym'},
{village:'Ranmuhu',province:'Malampa',island:'Ambrym'},
{village:'Ranon',province:'Malampa',island:'Ambrym'},
{village:'Rantuopongil',province:'Tafea',island:'Erromango'},
{village:'Ranverekon',province:'Malampa',island:'Ambrym'},
{village:'Ranvetlam',province:'Malampa',island:'Ambrym'},
{village:'Raovis',province:'Tafea',island:'Erromango'},
{village:'Ravanga',province:'Shefa',island:'Efate'},
{village:'Ravenga',province:'Shefa',island:'Tongoa'},
{village:'Ravuhen',province:'Malampa',island:'Awei'},
{village:'Ravuren',province:'Malampa',island:'Malekula'},
{village:'Red Stone',province:'Shefa',island:'Epi'},
{village:'Rembe',province:'Malampa',island:'Malekula'},
{village:'Remep',province:'Malampa',island:'Malekula'},
{village:'Renaur',province:'Malampa',island:'Malekula'},
{village:'Rensarie',province:'Malampa',island:'Malekula'},
{village:'Rentabao',province:'Shefa',island:'Efate'},
{village:'Repanvaun',province:'Malampa',island:'Malekula'},
{village:'Reparsivir',province:'Malampa',island:'Malekula'},
{village:'Rerep',province:'Malampa',island:'Malekula'},
{village:'Retchar',province:'Malampa',island:'Malekula'},
{village:'Retur',province:'Malampa',island:'Malekula'},
{village:'Rewoka Namalasi',province:'Shefa',island:'Nguna'},
{village:'Robanias',province:'Malampa',island:'Akhamb'},
{village:'Roma',province:'Malampa',island:'Rano'},
{village:'Ronevier',province:'Malampa',island:'Malekula'},
{village:'Rory',province:'Malampa',island:'Malekula'},
{village:'Rovo Bay',province:'Shefa',island:'Epi'},
{village:'Ruhumbo',province:'Malampa',island:'Malekula'},
{village:'Sadere',province:'Malampa',island:'Rano'},
{village:'Safuti',province:'Shefa',island:'Emae'},
{village:'Sahuot',province:'Malampa',island:'Ambrym'},
{village:'Sai Bethel',province:'Malampa',island:'Ambrym'},
{village:'Saikariaeken',province:'Tafea',island:'Tanna'},
{village:'Saint John',province:'Sanma',island:'Santo'},
{village:'Saint Joseph',province:'Malampa',island:'Atchin'},
{village:'Saint Peter',province:'Sanma',island:'Santo'},
{village:'Saint Pierre',province:'Malampa',island:'Malekula'},
{village:'Salenhtor',province:'Malampa',island:'Atchin'},
{village:'Salili',province:'Shefa',island:'Efate'},
{village:'Simonson',province:'Sanma',island:'Santo'},
{village:'Sameria',province:'Tafea',island:'Tanna'},
{village:'Samoa Point',province:'Shefa',island:'Efate'},
{village:'Sandra',province:'Shefa',island:'Epi'},
{village:'Sanesup',province:'Malampa',island:'Ambrym'},
{village:'Sangava',province:'Shefa',island:'Emae'},
{village:'Santar',province:'Malampa',island:'Malekula'},
{village:'Saomalo',province:'Shefa',island:'Efate'},
{village:'Sarapo',province:'Sanma',island:'Santo'},
{village:'Sarepta',province:'Malampa',island:'Wala'},
{village:'Sarmette',province:'Malampa',island:'Malekula'},
{village:'Sasake',province:'Shefa',island:'Emae'},
{village:'Savaki',province:'Shefa',island:'Efate'},
{village:'Saviu',province:'Shefa',island:'Tongoa'},
{village:'Seaside',province:'Shefa',island:'Efate'},
{village:'Sebughas',province:'Malampa',island:'Malekula'},
{village:'Selektasimal',province:'Malampa',island:'Malekula'},
{village:'Senai',province:'Malampa',island:'Ambrym'},
{village:'Senal',province:'Malampa',island:'Malekula'},
{village:'Serser',province:'Malampa',island:'Wala'},
{village:'Sesivi',province:'Malampa',island:'Ambrym'},
{village:'Severua',province:'Shefa',island:'Efate'},
{village:'Teouma Bay',province:'Shefa',island:'Efate'},
{village:'Sigon',province:'Malampa',island:'Vao'},
{village:'Sikenbo Primary School',province:'Shefa',island:'Epi'},
{village:'Silowe',province:'Shefa',island:'Lamen'},
{village:'Simbolo',province:'Shefa',island:'Efate'},
{village:'Sinowor',province:'Malampa',island:'Malekula'},
{village:'Sipiopu',province:'Tafea',island:'Erromango'},
{village:'Sirbubul',province:'Malampa',island:'Malekula'},
{village:'Siviri',province:'Shefa',island:'Efate'},
{village:'Siwo',province:'Shefa',island:'Emae'},
{village:'Small Tautu',province:'Malampa',island:'Malekula'},
{village:'Smet',province:'Shefa',island:'Efate'},
{village:'Socapo',province:'Shefa',island:'Efate'},
{village:'Sopon',province:'Malampa',island:'Uripiv'},
{village:'St Joseph (Malekula)',province:'Malampa',island:'Malekula'},
{village:'Stade',province:'Shefa',island:'Efate'},
{village:'Stella Marie',province:'Shefa',island:'Efate'},
{village:'Suasu',province:'Shefa',island:'Efate'},
{village:'Sulemaeto',province:'Sanma',island:'Santo'},
{village:'Sulol',province:'Malampa',island:'Ambrym'},
{village:'Sulua',province:'Shefa',island:'Emae'},
{village:'Sumalapa',province:'Shefa',island:'Efate'},
{village:'Sunae',province:'Shefa',island:'Moso'},
{village:'Switi',province:'Shefa',island:'Efate'},
{village:'Tabih',province:'Malampa',island:'Malekula'},
{village:'Tagabe',province:'Shefa',island:'Efate'},
{village:'Tagabe Bridge',province:'Shefa',island:'Efate'},
{village:'Tahal Nesa',province:'Malampa',island:'Paama'},
{village:'Tahal Netan',province:'Malampa',island:'Paama'},
{village:'Tahi',province:'Malampa',island:'Paama'},
{village:'Takarariki',province:'Shefa',island:'Efate'},
{village:'Takara',province:'Shefa',island:'Efate'},
{village:'Taliko',province:'Shefa',island:'Epi'},
{village:'Vatukiki',province:'Shefa',island:'Epi'},
{village:'Tamanu',province:'Shefa',island:'Efate'},
{village:'Tamasina',province:'Shefa',island:'Epi'},
{village:'Tamaunu',province:'Shefa',island:'Ifira'},
{village:'Tamate (Klem\'s Hill)',province:'Shefa',island:'Efate'},
{village:'Tanoliu',province:'Shefa',island:'Efate'},
{village:'Tanmalilip',province:'Malampa',island:'Malekula'},
{village:'Tanmial (Malekula)',province:'Malampa',island:'Malekula'},
{village:'Taolia',province:'Shefa',island:'Epi'},
{village:'Taunono',province:'Shefa',island:'Efate'},
{village:'Tapakoro',province:'Shefa',island:'Emae'},
{village:'Tapum',province:'Tafea',island:'Tanna'},
{village:'Taremb',province:'Malampa',island:'Malekula'},
{village:'Taremb Kiki',province:'Malampa',island:'Malekula'},
{village:'Tasiriki (Moso)',province:'Shefa',island:'Moso'},
{village:'Tasiriki (Vila)',province:'Shefa',island:'Efate'},
{village:'Tavaralapa',province:'Shefa',island:'Efate'},
{village:'Tavia',province:'Shefa',island:'Tongariki'},
{village:'Taviak',province:'Malampa',island:'Ambrym'},
{village:'Tavie',province:'Malampa',island:'Paama'},
{village:'Tavios',province:'Malampa',island:'Ambrym'},
{village:'Tavulai',province:'Malampa',island:'Paama'},
{village:'Tchinarmare',province:'Malampa',island:'Atchin'},
{village:'Teouma Bush (Eton)',province:'Shefa',island:'Efate'},
{village:'Tebakor',province:'Shefa',island:'Efate'},
{village:'Tembibi',province:'Malampa',island:'Malekula'},
{village:'Tenmaru',province:'Malampa',island:'Malekula'},
{village:'Tenmiel',province:'Malampa',island:'Malekula'},
{village:'Tennis',province:'Tafea',island:'Tanna'},
{village:'Teouma Bush',province:'Shefa',island:'Efate'},
{village:'Teouma (Pentecost Community)',province:'Shefa',island:'Efate'},
{village:'Teouma White Sands',province:'Shefa',island:'Efate'},
{village:'Teouma Bridge',province:'Shefa',island:'Efate'},
{village:'Teouma Bush (Eratap)',province:'Shefa',island:'Efate'},
{village:'Teouma Jeovah',province:'Shefa',island:'Efate'},
{village:'Teouma NTM',province:'Shefa',island:'Efate'},
{village:'Teouma Valley',province:'Shefa',island:'Efate'},
{village:'Teoumaville',province:'Shefa',island:'Efate'},
{village:'Deproma Bush',province:'Sanma',island:'Santo'},
{village:'Tepune',province:'Malampa',island:'Malekula'},
{village:'Tesmevis',province:'Malampa',island:'Malekula'},
{village:'Teupeev',province:'Malampa',island:'Malekula'},
{village:'Tevali',province:'Malampa',island:'Paama'},
{village:'Tevali Aot',province:'Malampa',island:'Paama'},
{village:'Tevri',province:'Malampa',island:'Uripiv'},
{village:'Tikelele',province:'Shefa',island:'Epi'},
{village:'Tikilasoa',province:'Shefa',island:'Nguna'},
{village:'Tisman',province:'Malampa',island:'Malekula'},
{village:'Tisnemtenwo',province:'Malampa',island:'Malekula'},
{village:'Tisvel',province:'Malampa',island:'Malekula'},
{village:'Tniu',province:'Malampa',island:'Malekula'},
{village:'Toak',province:'Malampa',island:'Ambrym'},
{village:'Tokove',province:'Shefa',island:'Ifira'},
{village:'Tokvanu',province:'Malampa',island:'Malekula'},
{village:'Tokyo',province:'Shefa',island:'Efate'},
{village:'Tomali',province:'Shefa',island:'Epi'},
{village:'Toman',province:'Malampa',island:'Tomman'},
{village:'Tongamea',province:'Shefa',island:'Emae'},
{village:'Tongbang',province:'Malampa',island:'Ambrym'},
{village:'Tontar',province:'Malampa',island:'Malekula'},
{village:'Tontarasak',province:'Malampa',island:'Malekula'},
{village:'Topol',province:'Malampa',island:'Ambrym'},
{village:'Tou',province:'Malampa',island:'Ambrym'},
{village:'Towaolul',province:'Tafea',island:'Tanna'},
{village:'Town Hall',province:'Malampa',island:'Malekula'},
{village:'Travol',province:'Malampa',island:'Malekula'},
{village:'Tsibetevnameus',province:'Malampa',island:'Malekula'},
{village:'Tsibunerets',province:'Malampa',island:'Malekula'},
{village:'Tsidavo',province:'Malampa',island:'Malekula'},
{village:'Tsinabon',province:'Malampa',island:'Rano'},
{village:'Tsinaimnani',province:'Malampa',island:'Malekula'},
{village:'Tsinembis',province:'Malampa',island:'Rano'},
{village:'Tsinetra',province:'Malampa',island:'Malekula'},
{village:'Tukutuku',province:'Shefa',island:'Efate'},
{village:'Tulwei',province:'Malampa',island:'Malekula'},
{village:'Turak',province:'Malampa',island:'Akhamb'},
{village:'Tutuk',province:'Shefa',island:'Efate'},
{village:'Tuwit',province:'Tafea',island:'Erromango'},
{village:'Udapua',province:'Shefa',island:'Nguna'},
{village:'Ulei',province:'Malampa',island:'Ambrym'},
{village:'Umakei',province:'Tafea',island:'Aneityum'},
{village:'Umkalau',province:'Tafea',island:'Aneityum'},
{village:'Umpon Yelogi (Happy Land)',province:'Tafea',island:'Erromango'},
{village:'Unakapu',province:'Shefa',island:'Nguna'},
{village:'Unavwolu',province:'Tafea',island:'Erromango'},
{village:'Undine Bay',province:'Shefa',island:'Efate'},
{village:'Unmakh',province:'Malampa',island:'Malekula'},
{village:'Unmet',province:'Malampa',island:'Malekula'},
{village:'Unomnagi',province:'Tafea',island:'Aneityum'},
{village:'Unorah',province:'Tafea',island:'Erromango'},
{village:'Unpongkor (Dillons Bay)',province:'Tafea',island:'Erromango'},
{village:'Uptapep',province:'Malampa',island:'Malekula'},
{village:'Uri',province:'Malampa',island:'Malekula'},
{village:'Utanlangi',province:'Shefa',island:'Pele'},
{village:'Utas',province:'Malampa',island:'Ambrym'},
{village:'Utche',province:'Tafea',island:'Tanna'},
{village:'V.L.D',province:'Shefa',island:'Efate'},
{village:'Vaemali',province:'Shefa',island:'Epi'},
{village:'Vaima',province:'Shefa',island:'Emae'},
{village:'Vaitini',province:'Shefa',island:'Emae'},
{village:'Valankara Village',province:'Sanma',island:'Santo'},
{village:'Valankara White Quary',province:'Sanma',island:'Santo'},
{village:'Vanmai',province:'Malampa',island:'Malekula'},
{village:'Vanruru',province:'Malampa',island:'Akhamb'},
{village:'Vaoleli',province:'Malampa',island:'Paama'},
{village:'Vaouleli Nessa',province:'Malampa',island:'Paama'},
{village:'Varak',province:'Malampa',island:'Malekula'},
{village:'Vatkao',province:'Shefa',island:'Efate'},
{village:'Venamboas',province:'Malampa',island:'Malekula'},
{village:'Vembaksambai',province:'Malampa',island:'Ambrym'},
{village:'Vengasis',province:'Malampa',island:'Malekula'},
{village:'Venu',province:'Malampa',island:'Vao'},
{village:'Vetan',province:'Malampa',island:'Malekula'},
{village:'Veturah',province:'Malampa',island:'Malekula'},
{village:'Vila North',province:'Shefa',island:'Efate'},
{village:'Vilavi',province:'Malampa',island:'Uripiv'},
{village:'Vinmavis',province:'Malampa',island:'Malekula'},
{village:'Vmf Camp',province:'Shefa',island:'Efate'},
{village:'Vutekai',province:'Malampa',island:'Paama'},
{village:'Waisisi (Efate)',province:'Shefa',island:'Efate'},
{village:'Waisisi (Tanna)',province:'Tafea',island:'Tanna'},
{village:'Wakon',province:'Malampa',island:'Ambrym'},
{village:'Wala Main Land',province:'Malampa',island:'Malekula'},
{village:'Walavea',province:'Shefa',island:'Epi'},
{village:'Wambi',province:'Shefa',island:'Epi'},
{village:'Weisir',province:'Malampa',island:'Malekula'},
{village:'Welwelepus',province:'Sanma',island:'Santo'},
{village:'Wenia',province:'Shefa',island:'Epi'},
{village:'Werearu',province:'Shefa',island:'Pele'},
{village:'Weso',province:'Malampa',island:'Malekula'},
{village:'White Grass',province:'Tafea',island:'Erromango'},
{village:'White Sands',province:'Shefa',island:'Efate'},
{village:'Wiana',province:'Shefa',island:'Emau'},
{village:'Wiaru',province:'Malampa',island:'Malekula'},
{village:'Wiawi',province:'Malampa',island:'Malekula'},
{village:'Wiel',province:'Malampa',island:'Malekula'},
{village:'Wiliekh',province:'Malampa',island:'Malekula'},
{village:'Wilit',province:'Malampa',island:'Ambrym'},
{village:'Wimandu',province:'Malampa',island:'Malekula'},
{village:'Win',province:'Malampa',island:'Malekula'},
{village:'Wintua',province:'Malampa',island:'Malekula'},
{village:'Woliliu',province:'Shefa',island:'Epi'},
{village:'Womul',province:'Malampa',island:'Malekula'},
{village:'Woralapa',province:'Shefa',island:'Nguna'},
{village:'Worari',province:'Malampa',island:'Malekula'},
{village:'Worasifiu',province:'Shefa',island:'Pele'},
{village:'Worauloa',province:'Shefa',island:'Efate'},
{village:'Woraviu',province:'Shefa',island:'Tongoa'},
{village:'Worburi',province:'Malampa',island:'Malekula'},
{village:'Worfiu',province:'Shefa',island:'Tongoa'},
{village:'Workshop',province:'Malampa',island:'Malekula'},
{village:'Worlep',province:'Malampa',island:'Malekula'},
{village:'Worles',province:'Malampa',island:'Malekula'},
{village:'Wormet',province:'Malampa',island:'Malekula'},
{village:'Wornambek',province:'Malampa',island:'Malekula'},
{village:'Wornari',province:'Malampa',island:'Malekula'},
{village:'Woromlaki',province:'Malampa',island:'Malekula'},
{village:'Wou',province:'Malampa',island:'Ambrym'},
{village:'Wowo',province:'Malampa',island:'Malekula'},
{village:'Yahlia',province:'Tafea',island:'Tanna'},
{village:'Yakasever',province:'Tafea',island:'Tanna'},
{village:'Yakel',province:'Tafea',island:'Tanna'},
{village:'Yakukak',province:'Tafea',island:'Tanna'},
{village:'Yakulpow',province:'Tafea',island:'Tanna'},
{village:'Yakumanerei',province:'Tafea',island:'Tanna'},
{village:'Yakun Aveuka',province:'Tafea',island:'Tanna'},
{village:'Yakunaus',province:'Tafea',island:'Tanna'},
{village:'Yakunaveuka',province:'Tafea',island:'Tanna'},
{village:'Yakunekaunun',province:'Tafea',island:'Tanna'},
{village:'Yalkis',province:'Tafea',island:'Tanna'},
{village:'Yallia',province:'Tafea',island:'Tanna'},
{village:'Yanakwa',province:'Tafea',island:'Tanna'},
{village:'Yanapuasiko',province:'Tafea',island:'Tanna'},
{village:'Yanapukul',province:'Tafea',island:'Tanna'},
{village:'Yanarawia',province:'Tafea',island:'Tanna'},
{village:'Yanemarai',province:'Tafea',island:'Tanna'},
{village:'Yaneumakel',province:'Tafea',island:'Tanna'},
{village:'Yaneumra',province:'Tafea',island:'Tanna'},
{village:'Yankuanenetata',province:'Tafea',island:'Tanna'},
{village:'Yankwa Neneai',province:'Tafea',island:'Tanna'},
{village:'Yankwa Nenepum',province:'Tafea',island:'Tanna'},
{village:'Yankwanemi',province:'Tafea',island:'Tanna'},
{village:'Yankwanpakar',province:'Tafea',island:'Tanna'},
{village:'Yanmilen',province:'Tafea',island:'Tanna'},
{village:'Yanumakel',province:'Tafea',island:'Tanna'},
{village:'Yaohnanen',province:'Tafea',island:'Tanna'},
{village:'Yapang Nawa',province:'Tafea',island:'Tanna'},
{village:'Yapkapen',province:'Tafea',island:'Tanna'},
{village:'Yapkeusep',province:'Tafea',island:'Tanna'},
{village:'Yapowul',province:'Tafea',island:'Tanna'},
{village:'Yarofi',province:'Tafea',island:'Tanna'},
{village:'Yaruareng',province:'Tafea',island:'Tanna'},
{village:'Yatakwas Kamil',province:'Tafea',island:'Tanna'},
{village:'Yatanas',province:'Tafea',island:'Tanna'},
{village:'Yataphum',province:'Tafea',island:'Tanna'},
{village:'Yatpalanien',province:'Tafea',island:'Tanna'},
{village:'Yatukuei',province:'Tafea',island:'Tanna'},
{village:'Yatukwas',province:'Tafea',island:'Tanna'},
{village:'Yautilie',province:'Malampa',island:'Ambrym'},
{village:'Yawenkula',province:'Tafea',island:'Tanna'},
{village:'Yawus',province:'Tafea',island:'Tanna'},
{village:'Yelahae',province:'Malampa',island:'Ambrym'},
{village:'Yelovuvu',province:'Malampa',island:'Ambrym'},
{village:'Yemtariwek',province:'Tafea',island:'Tanna'},
{village:'Yenaes',province:'Tafea',island:'Tanna'},
{village:'Yenakul',province:'Tafea',island:'Tanna'},
{village:'Yenamahu',province:'Tafea',island:'Tanna'},
{village:'Yenamu',province:'Tafea',island:'Tanna'},
{village:'Yenapkasu',province:'Tafea',island:'Tanna'},
{village:'Yenapuas',province:'Tafea',island:'Tanna'},
{village:'Yenata',province:'Tafea',island:'Tanna'},
{village:'Yenawan',province:'Tafea',island:'Tanna'},
{village:'Yenemaha',province:'Tafea',island:'Tanna'},
{village:'Yenhup',province:'Tafea',island:'Tanna'},
{village:'Yenpenarap',province:'Tafea',island:'Tanna'},
{village:'Yenpinan',province:'Tafea',island:'Tanna'},
{village:'Yenuglapang',province:'Tafea',island:'Tanna'},
{village:'Yeruareng',province:'Tafea',island:'Tanna'},
{village:'Yerutana',province:'Tafea',island:'Tanna'},
{village:'Yetalau',province:'Tafea',island:'Aneityum'},
{village:'Yetan Meren',province:'Tafea',island:'Tanna'},
{village:'Yetanmalen',province:'Tafea',island:'Tanna'},
{village:'Yetapu',province:'Tafea',island:'Tanna'},
{village:'Yetaus',province:'Tafea',island:'Tanna'},
{village:'Yevali',province:'Shefa',island:'Epi'},
{village:'Yopuna',province:'Shefa',island:'Epi'},
{village:'Yowa',province:'Shefa',island:'Epi'},
{village:'Yunaras',province:'Tafea',island:'Tanna'},
{village:'Yuniel',province:'Tafea',island:'Tanna'},
{village:'Yurnaip',province:'Tafea',island:'Tanna'}
];

/**
 * A control to capture and display a ni-Vanuatu postal addresses.
 * @component
 */
const AddressInputVU = ({address, live, placeholder, hideLabel = false, onChange, readonly, required, disabled: disabledInput, ...props}) => {
    const { t } = useTranslation();
    const disabled = useCallback((field) => {
        if (typeof disabledInput === 'function') {
            return disabledInput(field);
        } else {
            return !!disabledInput;
        }
    }, [disabledInput])

    const readonlyPlaceholder = useMemo(() => placeholder?.default ?? t('address'), [placeholder?.default, t]);
    const addressString = useMemo(() => (address?.address1 ? address.address1 + ', ' : '') 
                                        + (address?.address2 ? address.address2 + ', ' : '') 
                                        + (address?.suburb ? address.suburb + ', ' : '') 
                                        + (address?.state ? address.state + ', ' : '') 
                                        + (address?.postcode ? address.postcode : ''), 
        [address?.address1, address?.address2, address?.state, address?.suburb, address?.postcode]);

    const villages = useMemo(() => distinct(data.filter(v => (!address?.state || address?.state === v.island) && (!address?.postcode || address?.postcode === v.province)).map(v => v.village)), [data, address?.state, address?.postcode])
    const islands = useMemo(() => distinct(data.map(v => v.island).sort()), [data]);
    const provinces = useMemo(() => distinct(data.map(v => v.province)).sort(), [data]);

    const handleChangeSuburb = useCallback(suburb => {
        onChange('suburb', suburb);
        const entry = data.find(entry => entry.village === suburb);
        if (entry) {
            onChange('state', entry.island);
            onChange('postcode', entry.province);
        } else if (suburb) {
            onChange('state', null);
            onChange('postcode', null);
        }
    }, [data, onChange]);

    const handleChangeState = useCallback(state => {
        onChange('state', state);
        if (address?.suburb && !data.find(d => d.village === address?.suburb && d.island === state)) {
            onChange('suburb', null);
        }
        const province = distinct(data.filter(d => d.island === state).map(d => d.province));
        if (province?.length === 1) {
            onChange('postcode', province[0]);
        } else {
            onChange('postcode', null);
        }
    }, [data, address?.suburb, address?.postcode, onChange]);

    const handleChangePostcode = useCallback(postcode => {
        onChange('postcode', postcode);
        if (address?.suburb && !data.find(d => d.village === address?.suburb && d.province === postcode)) {
            onChange('suburb', null);
        }
        if (address?.state && !data.find(d => d.island === address?.state && d.province === postcode)) {
            onChange('state', null);
        }
    }, [data, address?.suburb, address?.state, onChange]);

    return (readonly ? <Label placeholder={readonlyPlaceholder} hideLabel={hideLabel} text={addressString} {...props}></Label> : <>
    <Row>
        <Col><TextInput live={live} maxLength={256} placeholder={placeholder?.address1 ?? t('address1')} value={address?.address1} hideLabel={hideLabel} onChange={a => onChange('address1', a)} required={required} disabled={disabled('address1')} {...props}></TextInput></Col>
    </Row>
    <Row>
        <Col><TextInput live={live} maxLength={256} placeholder={placeholder?.address2  ?? t('address2')} value={address?.address2} hideLabel={hideLabel} onChange={a => onChange('address2', a)} disabled={disabled('address2')} {...props}></TextInput></Col>
    </Row>
    <Row>
        <Col md={4}>
            <TypeaheadInput live={live} maxLength={256} placeholder={placeholder?.suburb ?? t('areaCouncil')} value={address?.suburb} hideLabel={hideLabel} onChange={handleChangeSuburb} required={required} disabled={disabled('suburb')} {...props}
                options={villages} lockdown={true}></TypeaheadInput>
        </Col>
        <Col md={4}>
            <Select placeholder={placeholder?.state ?? t('island')} value={address?.state} hideLabel={hideLabel} onChange={handleChangeState} required={required} options={islands} disabled={disabled('state')} {...props}></Select>
        </Col>
        <Col md={4}>
            <Select placeholder={placeholder?.postcode ?? t('province')} maxLength={8} value={address?.postcode} hideLabel={hideLabel} onChange={handleChangePostcode} required={required} options={provinces} disabled={disabled('postcode')} {...props}></Select>
        </Col>
    </Row>
    </>)
}

AddressInputVU.propTypes = {
    /**
     * The object in which the address fields should be stored
     */
    address: PropTypes.object,

    /**
     * Set to true for every key stroke to call the onChange function
     */
    live: PropTypes.bool,

    /**
     * A map of placeholders for each of the address components
     */
    placeholder: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.string), PropTypes.oneOf([''])]), 

    /**
     * Supress text labels but leave label spacing
     */
    hidePlaceholders: PropTypes.bool,

    /**
     * Copllapse label spacing
     */
    hideLabel: PropTypes.bool,

    /**
     * Force the input to be read-only
     */
        readonly: PropTypes.bool,

    /**
     * A function called whenever an address field is updated.
     * The function takes a field name and the new value to be assigned to that field.
     */
    onChange: PropTypes.func,

    /**
     * The control must have a value for the from in which it is contained to validate
     */
    required: PropTypes.bool
}

export default AddressInputVU;
